<template>
  <div style="width:100vw;height:100vh;font-family:PingFang SC;user-select:none;">
    <div class="head">
      <div class="head-title">
        <img src="../../static/img/logo.png" class="head-logo" />
        篁岭景区旅游大数据中心
      </div>
      <div class="head-type">
        <div class="type-item" v-for="item in type_item" :key="item.value"
          :class="{ 'type-item2': item.value == typeIndex }" @click="typeChange(item.value)">
          {{ item.label }}
          <div class="type-on" v-if="item.value == typeIndex"></div>
        </div>
      </div>
      <div>
        <div class="date-weather">
          <div class="changeDateOne" @click="changeTheDate(-1)">前一天</div>
          <div class="changeDateOne" @click="changeTheDate(0)">今&nbsp;&nbsp;天</div>
          <div class="changeDateOne" @click="changeTheDate(1)">后一天</div>
          <img @click="getWeatherData(1)" src="../../static/img/refresh-ccw.png" style="
              display: inline-block;
              width: 14px;
              height: 14px;
              vertical-align: middle;
              transform: translate(0, -2px);
              cursor: pointer;
            " v-if="isToday" />
          {{ isToday ? nowDay : req_date.replace('-', '/') }} {{ isToday ? week : changeWeek }} {{ isToday ? nowTime :
            '' }}
          <!-- <span v-if="isToday"> 暂时隐藏天气
            <span style="margin: 0 6px; color: rgba(255, 255, 255, 0.5)">|</span>
            {{weather.temperature}}ºC
            <img
              src="../../static/img/water.png"
              style="
                display: inline-block;
                width: 14px;
                height: 14px;
                vertical-align: middle;
                transform: translate(0, -2px);
              "
            />
            {{weather.humidity}}%
            <img
              src="../../static/img/Vector.png"
              style="
                display: inline-block;
                width: 12px;
                height: 10px;
                vertical-align: middle;
                transform: translate(0, -2px);
              "
            />
            {{weather.winddirection}}{{weather.windpower}}
          </span> -->

        </div>
      </div>
    </div>

    <div class="main" id="bodys">
      <ScenicWarning v-if="typeIndex == 4" :embedded="true" />
           <div id="migrateMap" class="migrateMap" :style="{ 'height': bodyHeight + 'px' }"
        v-show="typeIndex == 0 || typeIndex == 1"></div>
      <div class="centenrBox centenr-echart" v-show="typeIndex == 2">
        <!-- <div class="right-title" style="padding-top:36px;text-align: center;font-size: 18px;">30天销售对比图</div> -->
        <div class="all_or_shop">
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 1 }" style="margin-right: 48px;"
            @click="changeAllShop(1)">总营收</div>
          <div class="all_or_shop_btn" :class="{ 'all_or_shop_on': allShopIndex === 2 }" @click="changeAllShop(2)">商户明细
          </div>
        </div>
        <div v-show="allShopIndex === 1" id="thirtyDays" class="centenrBox-chart"></div>
        <div v-show="allShopIndex === 2" class="shop-charts-btn">
          <div id="shopRank" v-show="merchant_order_total_list.length <= 40" class="shop-charts-01"></div>
          <div id="shopRank_1" v-show="merchant_order_total_list.length > 40" class="shop-charts-02"></div>
          <div v-show="merchant_order_total_list.length > 40" id="shopRank_2" class="shop-charts-02"
            style="margin-left: 48px;"></div>
        </div>
      </div>
      <div v-show="typeIndex == 0" class="main_type">
        <div class="center-top-num ">
          <div class="left-top-title center-big-title">
            <span>今日入园</span>
          </div>
          <div class="today-sum-one">
            <div class="year-sum-big" style="line-height:96px">
              <div class="center-icon">,</div>
              <div v-for="(item, index) in dateSum" :key="index" class="sum-one-big">
                <!-- <span>{{item}}</span> -->
                <CountFlop :val="item" />

              </div>
            </div>
          </div>
        </div>
        <div class="main-left">
          <div class="heat-address">
            客源地
            <img style="margin-left:4px;width:1px;height:12px;" src="../../static/img/Rectangle 234.png">
            <img style="width:23px;height:23px;" src="../../static/img/chevron_down.png">
          </div>
          <div class="left-top  data-box">
            <div class="left-top-main">
              <div class="left-top-title flex ">
                <span style="margin-right:14px;font-weight:600;font-size:24px">全年游客总量</span>
                <span style="font-weight:400;font-size:14px">{{ isToday ? nowDay.slice(0, 4) : req_date.slice(0, 4)
                }}年</span>
                <img v-if="!isYearSumShow" style="width: 35px;height: 22px;margin-left: 40px;"
                  src="../../static/img/bg-display.png" alt="" @click="isDataShow(false)">
                <img v-if="isYearSumShow" style="width: 30px;height: 20px;margin-left: 40px;"
                  src="../../static/img/bg-hide.png" alt="" @click="isDataShow(true)">
              </div>
              <div class="year-sum-box">
                <div class="year-sum">
                  <div v-for="(item, index) in yearSum" :key="index" class="sum-one">
                    <span v-if="isYearSumShow">{{ item }}</span>
                    <span v-if="!isYearSumShow">*</span>
                  </div>

                </div>
              </div>

              <div style="margin-top:10px;display:inline-block;text-align:center">
                <img src="../../static/img/rectangle.png" style="width:283px;height:2px">
              </div>
              <div class="today-sum">
                <div class="today-one">
                  <div class="today-one-title">今日在园游客总量</div>
                  <div style="position:relative;width:100%;text-align:left;">
                    <div class="today-one-sum">
                      <div class="today-one-sum-box">
                        <div v-for="(item, index) in dateInSum" :key="index" class="today-one-num">
                          {{ item }}
                        </div>
                      </div>

                      <img src="../../static/img/rectangle-vertical.png"
                        style="position: absolute;width:1px;height:32px;top:50%;transform: translate(0,-50%);right:-0.5px">
                    </div>
                  </div>
                  <div class="last-num">
                    <div style="margin:12px 0 13px;">
                      <span class="title-small">昨日游客</span>
                      <span class="number-small">{{ yesterday_tourists_num }}</span>
                    </div>
                    <div>
                      <span class="title-small">上月同期</span>
                      <span v-if="isYearSumShow" class="number-small">{{ last_mouth_tourists_num }}</span>
                      <span v-if="!isYearSumShow" class="number-small">****</span>
                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <div class="today-one-title">今日出园游客总量</div>
                  <div style="position:relative;width:100%;text-align:right;">
                    <div class="today-one-sum">
                      <div class="today-one-sum-box">
                        <div v-for="(item, index) in dateOutSum" :key="index" class="today-one-num">
                          {{ item }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="last-num" style="padding-left:10px">
                    <div style="margin:12px 0 13px;">
                      <span class="title-small">本月游客</span>
                      <span v-if="isYearSumShow" class="number-small">{{ mouth_tourists_num }}</span>
                      <span v-if="!isYearSumShow" class="number-small">****</span>
                    </div>
                    <div>

                      <span class="title-small">去年同期</span>
                      <span v-if="isYearSumShow" class="number-small">{{ last_years_tourists_num }}</span>
                      <span v-if="!isYearSumShow" class="number-small">****</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="left-center data-box">
            <div style="font-size: 16px;">当日在园游客量预警</div>
            <div class="inPercentage">
              <div class="saturation">
                <div id="saturation" class="saturation-per"></div>
                <div class="inPercentageRemark">
                  <img class="little-bar" src="../../static/img/little-bar-p.png" />
                  <span style="color:#fff;font-size:10px">在园游客占园区可容纳占比</span>
                </div>

              </div>
              <div class="saturation">
                <div id="sellPer" class="saturation-per"></div>
                <div class="inPercentageRemark">
                  <img class="little-bar" src="../../static/img/little-bar-b.png" />
                  <span style="color:#fff;font-size:10px">当日售票占比</span>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          <div class="left-bottom data-box">
            <div class="left-bottom-title">渠道客流分析</div>
            <div class="gender" style="height:200px;">
              <div style="width:110px;display:inline-block;vertical-align: top;">
                <div id="ota_pie_1" class="ota_pie"></div>
                <div style="margin-left:18px">
                  <div v-for="(item, index) in ote_type_sale_person_list" :key="index" class="pie-text-item">
                    <div class="pie-dot" :style="{ 'background-color': pieColor[index] }"></div>{{ item[0].slice(0, 2)
                    }}
                  </div>
                </div>
              </div>
              <div id="travelPerson" class="travel-person"></div>
            </div>
          </div>
        </div>
        <div class="main-center">
          <div class="charts">
            <div class="inOrOut data-box">
              <div class="right-title" style="padding:11px">游客进出园时间分析</div>
              <div id="inOrOut" class="inOrOut-chart"></div>
            </div>
            <div class="inTime data-box">
              <div class="right-title" style="padding:11px">实时客流趋势</div>
              <div id="inTime" class="inTime-chart"></div>
            </div>

          </div>
        </div>
        <div class="main-right">
          <div class="right-top data-box">
            <div class="right-title">
              三天待入园人数
            </div>
            <div>
              <div id="waitInPart" class="travel-person" style="height: 230px;width: 180px;display:inline-block"></div>
              <div class="three-day">
                <div style="margin-bottom:10px;font-size:15px">
                  待入园渠道分析
                </div>
                <div v-for="(item, index) in three_show" :key="index" style="margin-bottom:6px">
                  {{ item.text }}
                </div>

                <div style="width: 128px;height: 128px;margin-left:-10px" id="three_pie"></div>
              </div>
            </div>
          </div>
          <div class="right-center data-box">
            <div class="right-title">
              客流峰值分析
            </div>
            <div id="peakLine" class="touristLine"></div>
          </div>
          <div class="right-bottom data-box">
            <div class="right-title">
              游客客流分析
              <div class="right-datetiem">
                周
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
            </div>
            <div id="touristLine" class="touristLine"></div>
          </div>
        </div>
      </div>
      <div v-show="typeIndex == 1" class="main_type">
        <div class="main-left">
          <div class="right-top data-box" style="height: 260px;margin-top:18px;">
            <div class="right-title">入园游客类型统计</div>
            <div id="touristType_1" class="touristType" style="height: 200px;width: 300px;"></div>
          </div>
          <div class="right-center data-box">
            <div class="right-title">
              客源地统计
              <div class="right-datetiem">
                日
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div class="addressList">
                <div v-for="(item, index) in origin_list_dict.o_address_list" :key="index" class="addressListOne">
                  {{ item.slice(0, 2) }}</div>
                <div class="addressBar" id="addressBar_1"></div>
              </div>
            </div>
            <div id="address_1" class="address"></div>
          </div>
          <div class="left-bottom data-box">
            <div class="left-bottom-title">游客性别及时间安排</div>
            <div class="gender">
              <div class="a-gender">
                <img src="../../static/img/man.png">
                <div class="gender-content" style="margin-top:8px">男</div>
                <div class="gender-content" style="margin-top:5px">{{ menP.toFixed(1) }}%</div>
              </div>
              <div class="a-gender">
                <img src="../../static/img/woman.png">
                <div class="gender-content" style="margin-top:8px">女</div>
                <div class="gender-content" style="margin-top:5px">{{ womenP.toFixed(1) }}%</div>
              </div>
              <div id="gender_1" class="gender-column"></div>
            </div>
            <div style="margin-top:27px;text-align:center">
              <img src="../../static/img/rectangle.png" style="margin:7px auto;width:283px;height:2px">
            </div>
            <div class="gender">
              <div class="right-datetiem" style="top:0;right:10px">
                昨
                <img style="margin-left:4px;width:1px;height:9px;" src="../../static/img/Rectangle 234.png">
                <img style="width:18px;height:18px;" src="../../static/img/chevron_down.png">
              </div>
              <div id="matinee_evening_1" class="matinee"></div>
              <div id="time_1" class="gender-column"></div>
            </div>
          </div>
          <!--
          <div class="cityCome data-box" style="margin-top:36px">
            <div class="right-title" style="text-align:center">
              <div class="city-btn" @click="drawOldCome(1)" :class="{'onOldCome': oldComeIndex == 1}">老年</div>
              <div class="city-btn" @click="drawOldCome(2)" :class="{'onOldCome': oldComeIndex == 2}">中年</div>
              <div class="city-btn" @click="drawOldCome(3)" :class="{'onOldCome': oldComeIndex == 3}">青少</div>
              <div class="city-btn" @click="drawOldCome(4)" :class="{'onOldCome': oldComeIndex == 4}">亲子</div>
              <div class="city-btn" @click="drawOldCome(5)" :class="{'onOldCome': oldComeIndex == 5}">均衡</div>
            </div>
            <div style="padding:0 22px;font-size:16px">{{oldComeName}}客源市场(占比)TOP10</div>
            <div id="oldCome" class="cityCome-chart" style="height: 234px;"></div>
          </div> -->
        </div>
        <div class="main-right" style="width:360px">
          <div class="cityCome data-box">
            <div class="right-title" style="padding-bottom:0">
              城市客源年龄结构分析
              <input type="text" class="cityInput" v-model="city_name">
              <div class="city-btn" @click="getCityCome()">查询</div>
            </div>
            <div style="padding:0 22px;font-size:16px">{{ now_city_name }}</div>
            <div id="cityCome" class="cityCome-chart"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px">
            <div class="right-title" style="text-align:center;padding-bottom: 10px;">
              <div class="city-btn" @click="drawOldCome(1)" :class="{ 'onOldCome': oldComeIndex == 1 }">老年</div>
              <div class="city-btn" @click="drawOldCome(2)" :class="{ 'onOldCome': oldComeIndex == 2 }">中年</div>
              <div class="city-btn" @click="drawOldCome(3)" :class="{ 'onOldCome': oldComeIndex == 3 }">青少</div>
              <div class="city-btn" @click="drawOldCome(4)" :class="{ 'onOldCome': oldComeIndex == 4 }">亲子</div>
              <div class="city-btn" @click="drawOldCome(5)" :class="{ 'onOldCome': oldComeIndex == 5 }">均衡</div>
            </div>
            <div style="padding:0 22px;font-size:16px">{{ oldComeName }}客源市场(占比)TOP10</div>
            <div id="oldCome" class="cityCome-chart" style="height: 180px;"></div>
          </div>
          <div class="cityCome data-box" style="margin-top:18px;height: 250px;">
            <div class="right-title" style="padding-bottom:0">游客复游率</div>
            <div class="gender" style="margin-top:0;height:168px;">
              <div style="display:inline-block">
                <div style="margin-left:10px;">
                  <div class="a-gender">
                    <img src="../../static/img/man.png">
                    <div class="gender-content" style="margin-top:8px">男</div>
                    <div class="gender-content" style="margin-top:5px">{{ re_sex.man ? re_sex.man.toFixed(1) : 0 }}%
                    </div>
                  </div>
                  <div class="a-gender">
                    <img src="../../static/img/woman.png">
                    <div class="gender-content" style="margin-top:8px">女</div>
                    <div class="gender-content" style="margin-top:5px">{{ re_sex.woman ? re_sex.woman.toFixed(1) : 0 }}%
                    </div>
                  </div>
                </div>
                <div id="re_pie" class="gender-column" style="width: 118px;height:108px;margin-top:18px"></div>
              </div>
              <div id="re_bar" class="travel-person"></div>

            </div>
          </div>
        </div>

      </div>
      <div v-show="typeIndex == 2" class="main_type">
        <div class="main-left" style="width: 360px;">
          <div class="left-top  data-box" style="padding-top: 15px;height: 233px;">
            <div class="left-top-main">
              <div class="left-top-title">
                <span style="margin-right:14px;font-weight:600;font-size:24px">票务交易额</span>
              </div>
              <div class="number-big" style="text-align: left;">
                {{ tradingNum.scenic_spot_volume }}
              </div>
              <div class="today-sum">
                <div class="today-one">
                  <div class="last-num">
                    <div style="margin:13px 0">
                      <span class="title-small-third">大门票</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.packages_ticket_volum }}</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">线上售票</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.second_pin_ticket_volum }}</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">OTA售票</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{ tradingNum.ota_sale_volume
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <div class="last-num" style="margin-left: 18px;">
                    <div style="margin:13px 0;">
                      <span class="title-small-third">二销票</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.second_pin_ticket_volum }}</span>
                    </div>
                    <div style="margin-bottom:13px;">
                      <span class="title-small-third">线下销售</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.offline_window_volume }}</span>
                    </div>
                    <div style="margin-bottom:13px;">
                      <span class="title-small-third">旅行社售票</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.tourist_window_volume }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="rank-box">
              <div class="right-title" style="font-size: 13px;">OTA交易额排名Top10</div>
              <div id="OTArank" class="rank-charts" style="width:168px;height: 266px;"></div>
            </div>
            <div class="rank-box">
              <div class="right-title" style="font-size: 13px;">旅行社交易额排名Top10</div>
              <div id="travelRank" class="rank-charts" style="width:168px;height: 268px;"></div>
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 280px;">
            <div class="right-title">销售金额占比(产品)</div>
            <div class="gender" style="height: 200px;">
              <div class="matinee" style="width: 48%;height: 200px;">
                <div v-for="(item, index) in productMoneyList" :key="index" style="margin-bottom: 6px;">
                  <div class="charts-percent">
                    <div class="ticket-dot" style="display: inline-block;"
                      :style="{ 'background-color': pieColor[index] }"></div>
                    {{ item.name.slice(0, 5) }}:{{ item.data }}
                  </div>
                </div>
              </div>
              <div id="productMoney" class="matinee" style="width: 48%;height: 180px;vertical-align: top;"></div>
            </div>
          </div>
        </div>
        <div class="main-right" style="width: 360px;">
          <div class="right-top data-box" style="padding: 15px;height: 233px;">
            <div class="left-top-main">
              <div class="left-top-title">
                <span style="margin-right:14px;font-weight:600;font-size:24px">餐酒交易额</span>
              </div>
              <div class="number-big" style="text-align: left;">
                {{ tradingNum.hotel_sales_revenue ? (Number(tradingNum.hotel_sales_revenue) +
                  Number(tradingNum.delicious_food_sales_revenue)).toFixed(2) : 0 }}
              </div>
              <div class="today-sum">
                <div class="today-one">
                  <div class="last-num">
                    <div style="margin:13px 0">
                      <span class="title-small-third">入住房间数</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{ hotelData.stay_in_room_num
                      }}</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">平均房价</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{ hotelData.ave_house_prices
                        ? hotelData.ave_house_prices.toFixed(2) : 0 }}</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">餐饮交易额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.delicious_food_sales_revenue }}</span>
                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <div class="last-num" style="margin-left: 18px;">
                    <div style="margin:13px 0">
                      <span class="title-small-third">酒店交易额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        tradingNum.hotel_sales_revenue ? tradingNum.hotel_sales_revenue.toFixed(2) : 0 }}</span>
                    </div>
                    <div style="margin-bottom:13px;">
                      <span class="title-small-third">入住率</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{ hotelData.stay_in_rate ?
                        (hotelData.stay_in_rate * 100).toFixed(2) : 0 }}%</span>
                    </div>
                    <div style="margin-bottom:13px;">
                      <span class="title-small-third">翻台率</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{ tableTurnoverRate
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 278px;">
            <div class="right-title">酒店订单房费排序Top10</div>
            <div style="width: 360px;height:200px">
              <div class="rank-box" style="width: 180px;">
                <div id="hotelRank" class="rank-charts" style="width:180px;height: 200px;"></div>
              </div>
              <div class="rank-box" style="width: 150px;vertical-align: top;">
                <div class="right-title" style="padding: 0px;">市别</div>
                <div id="type_pie" class="gender-column" style="width: 128px;height:168px;"></div>
              </div>
            </div>

          </div>
          <div class="right-top data-box" style="padding: 15px;height: 280px;margin-top: 18px;">
            <div class="left-top-main">
              <div class="left-top-title" style="line-height: 26px;">
                <span style="margin-right:14px;font-weight:600;font-size:24px">零售交易额</span>
                <div class="number-big" style="text-align: left;display: inline-block;font-size: 25px;margin-top: 0;">
                  {{ tradingNum.offline_retail_sales_volume ?
                    Number(tradingNum.offline_retail_sales_volume) + Number(tradingNum.shop_order_volume) : 0 }}
                </div>
              </div>

              <div class="today-sum">
                <div class="today-one">
                  <div class="last-num">
                    <div style="margin:13px 0">
                      <span class="title-small-third">商户零售额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">{{
                        businessNum.today_merchant_order_total }}</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">人均消费额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">
                        {{ tradingNum.in_park_num ? (tradingNum.today_total_amount / tradingNum.in_park_num).toFixed(2)
                          : 0 }}
                      </span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">线下零售额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">
                        {{ tradingNum.offline_retail_sales_volume ? tradingNum.offline_retail_sales_volume : 0 }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="today-one">
                  <div class="last-num" style="margin-left: 18px;">
                    <div style="margin:13px 0">
                      <span class="title-small-third">商管分佣额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">
                        {{ (Number(businessNum.wx_merchant_paid_in_total) +
                          Number(businessNum.zfb_merchant_paid_in_total)).toFixed(2) }}
                      </span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">人均分佣额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;"
                        v-if="(Number(total_tourists_num) + Number(free_check_gate_record_num)) > 0">
                        {{ ((Number(businessNum.wx_merchant_paid_in_total) +
                          Number(businessNum.zfb_merchant_paid_in_total)) /
                          (Number(total_tourists_num) + Number(free_check_gate_record_num))).toFixed(2) }}
                      </span>
                      <span v-else>0</span>
                    </div>
                    <div style="margin-bottom:13px">
                      <span class="title-small-third">电商零售额</span>
                      <span class="number-small" style="margin-left: 6px;font-size: 15px;">
                        {{ tradingNum.shop_order_volume }}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
              <div style="position: relative;">
                <div class="right-title" style="padding:0">商户订单金额Top10</div>
                <div class="charts">
                  <div id="businessRank" class="inOrOut-chart" style="width:333px;height:100px;"></div>
                </div>
              </div>

            </div>
          </div>
          <!-- <div class="inOrOut data-box" style="width: 360px;margin-top: 18px;height: 248px;">

          </div> -->

        </div>
      </div>
      <div v-show="typeIndex == 3" class="sentiment-box">
        <div class="sentiment-left" style="width: 400px;">
          <div ref="timeTrend" class="inOrOut data-box" style="width: 400px;height: 300px;padding: 15px;">

          </div>
          <div ref="mediaType" class="inOrOut data-box"
            style="width: 400px;margin-top: 80px;height: 300px;padding: 15px;">

          </div>
        </div>
        <div class="sentiment-body">
          <div class="body-left  data-box">
            <div class="body-title">
              舆情动态
            </div>
            <div class="list-box">
              <div v-for="(item, index) in tendenciesList" :key="index">
                <div class="list-item" @click="handleDetail(item)">
                  <div class="item-header">
                    <div class="avatar">
                      <img v-if="item.userHead" :src="item.userHead"></img>
                      <div v-else style="background-color: #fff;"></div>
                    </div>
                    <div class="header-content">
                      <div class="header-content-left">
                        <div class="title">{{ item.nickName || item.userName || item.websiteName }}</div>
                        <div class="content">
                          <span>{{ item.createAt }}</span>
                          <span style="margin-left: 5px;">{{ `- 来源:${item.websiteName || '未知'}` }}</span>
                          <span style="margin-left: 5px;">{{ `- IP:${item.ipLocation || '未知'}` }}</span>
                        </div>
                      </div>
                      <div class="header-content-right" @click.stop="toUrl(item.url)">原帖<i
                          class="el-icon-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                  <div class="item-tap" style="padding: 0 13px;">
                    <div style="width: 34px;">标签: </div>
                    <div class="tap-list">
                      <div class="tap" v-for="(tap, index) in taps(item.region)" :key="tap">#{{ tap }}</div>
                    </div>
                  </div>
                  <div class="item-body">
                    <div class="body-text" v-html="highlightText(strictClean(item.content), item.matchKeywords)">
                    </div>
                    <div class="body-images">
                      <div class="images-list" ref="imagesList">
                        <div class="prev" @click.stop="prevImage(index)"
                          v-if="actIndex > 0 && imageList(item.imageUrl).length > 3"><i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="next" @click.stop="nextImage(index)"
                          v-if="actIndex < (imageList(item.imageUrl).length - 3) && imageList(item.imageUrl).length > 3">
                          <i class="el-icon-arrow-right"></i>
                        </div>
                        <div v-if="imageList(item.imageUrl).length > 3" class="img-total">{{ `(${actIndex +
                          1}-${actIndex +
                          3})
                          / ${imageList(item.imageUrl).length}` }}</div>
                        <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(item.imageUrl)" :src="url"
                          :key="index">
                      </div>
                    </div>
                  </div>
                  <div class="item-footer">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="isDetail">
            <div class="body-title">
              舆情详情
              <span style="float: right;margin-right: 10px;cursor: pointer;" @click="isDetail = !isDetail">X</span>
            </div>
            <div class="box-right list-item" v-if="tendenciesItem.antduId">
              <div class="right-header">
                <div class="item-header">
                  <div class="avatar">
                    <img v-if="tendenciesItem.userHead" :src="tendenciesItem.userHead"></img>
                    <img v-else style="background-color: #fff;"></img>
                  </div>
                  <div class="header-content">
                    <div class="header-content-left">
                      <div class="title">{{ tendenciesItem.nickName || tendenciesItem.userName ||
                        tendenciesItem.websiteName }}</div>
                      <div class="content">
                        <span>{{ tendenciesItem.createAt }}</span>
                        <span style="margin-left: 5px;">{{ tendenciesItem.websiteName ? `-
                          ${tendenciesItem.websiteName}` :
                          ''
                        }}</span>
                        <span style="margin-left: 5px;">{{ `- IP:${tendenciesItem.ipLocation || '未知'}` }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-body item-body">
                <div class="item-tap">
                  <div style="width: 30px;">标签: </div>
                  <div class="tap-list">
                    <div class="tap" v-for="(tap, index) in taps(tendenciesItem.region)" :key="tap">#{{ tap }}</div>
                  </div>
                </div>
                <div class="right-body-text"
                  v-html="highlightText(imgText(tendenciesItem.content), tendenciesItem.matchKeywords)"></div>
                <div class="right-body-images" v-if="isImg(tendenciesItem.content)">
                  <img referrerPolicy="no-referrer" v-for="(url, index) in imageList(tendenciesItem.imageUrl)"
                    :src="url" :key="index">
                </div>
              </div>
              <div class="item-footer">
              </div>
            </div>
          </div>
          <div style="margin-left: 10px;" class="body-right data-box" v-if="!isDetail">
            <div class="body-title">
              舆情列表
            </div>
            <div class="timeline">
              <div v-for="(value, key, i) in timelineList" :key="key">
                <div class="timeline-date">
                  <div class="date-span">
                    <div class="date-item1"></div>
                  </div>
                  <div class="date">{{ key }}</div>
                </div>
                <div v-for="(item, index) in value" :key="index" class="timeline-item">
                  <div class="timeline-content" style="width:100%">
                    <div class="timeline-span">
                      <div class="span-item1"></div>
                    </div>
                    <div class="timeline-time">{{ item.time }}</div>
                    <div class="timeline-text" @click="toUrl(item.url)">
                      <span style="color: #d6a450;" v-if="item.emotionStr === '负面'">(疑似负面)</span>
                      <span style="color: red;" v-if="item.emotionStr === '差评'">(负面)</span>
                      <span v-html="highlightText(item.title, item.matchKeywords)" style="margin-right: 10px;"></span>
                      <span style="font-size: 14px;color: #b2b2b2;"
                        v-html="highlightText(strictClean(item.content), item.matchKeywords)"></span>
                    </div>
                    <div class="timeline-website">
                      {{ item.websiteName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sentiment-right" style="width: 400px;">
          <div ref="emotion" class="right-top data-box" style="width: 400px;padding: 15px;height: 300px;">

          </div>
          <div ref="hotWeb" class="right-top data-box"
            style="width: 400px;padding: 15px;height: 300px;margin-top: 80px;">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountFlop from '../components/CountFlop/CountFlop.vue'
import ScenicWarning from './ScenicWarning.vue'
import store from '@/store/index'
import {
  getSettingByIdApi, planeFigure, ticketNumberStatistics,
  realTimeTraffic, currentTrafficTrend, originList,
  realTouristsData, historyTouristsData, genderScheduleData,
  weatherData, getDataCustomerSourceMarketApi, getDataMainSourceMarketApi,
  getAnalysisMonthApi, getTradingNumApi, getTouristAgencyType,
  getSalesNumApi, xcxGetHotelDataApi, getMerchantOrder,
  getMerchantOrderList, getBigDataOfflineRetailInfo, salesComparisonApi,
  getDataRepurchaseAnalysisApi, getWaitingInApi, xcxGetDeliciousFoodDataApi, getCoefficientDataSettingApi
} from '../api/ScenicAPI'
import {
  getIotScenicHistoryData, getIotScenicVillageRealData, getIotScenicVillageTrend, iotSettingData,
} from '../api/ScenicIotApi'
import {
  get_subscribe_info_list, get_dynamic_subscribe_info_list, get_dynamic_subscribe_info_detail,
  get_subscribe_time_trend
} from '../api/sentiment'

import echarts from 'echarts'
import { parseTime, debounce } from '@/utils/index'
import { color } from 'echarts/lib/export'
var arcData = [];
var heatData = []
export default {
  components: {
    CountFlop,
    ScenicWarning,
  },
  data() {
    return {
      geoCoordMap: {}, //  全国省份。  也不能叫全省吧。 就是所有数据要展示的经纬度。

      type_item: [
        { label: '文旅市场', value: 0 },
        { label: '客流分析', value: 1 },
        { label: '营收分析', value: 2 },
        { label: '客流预警', value: 4 }
      ],
      // ,"营收分析"
      typeIndex: 0,
      yearSum: [],
      dateSum: [],
      dateInSum: [],
      dateOutSum: [],
      crowding: '',//在园游客饱和度
      mouth_tourists_num: '',//本月游客
      yesterday_tourists_num: '',//昨日游客
      last_mouth_tourists_num: '',//上月游客
      last_years_tourists_num: '',//去年游客
      gender: {},//性别数据
      menP: 0,//男占比
      womenP: 0,//女占比
      schedule: [],//时间
      // temperature:'',//温度
      // winddirection:'',//风向
      // windpower:'',//风力
      nowDay: '',//今天日期
      nowYear: '',//现在年份
      week: '',//星期几
      nowTime: '',//时分秒
      tourists_list: {},//游客入园时间统计
      real_time_traffic_list: {},//游客客流分析
      current_traffic_trend: {
        categories: [],
        series: [],
      },//游客进出园时间分析
      ticket_number_statistics: {},//入园游客类型统计
      weather: {},
      scenic_id: '',
      req_date: null,
      bodyHeight: '',
      originType: ['全部', '散客', '团队'],
      isShowType: false,
      originIndex: 0,
      origin_list_dict: {},
      flightMap: null,
      hotMap: '',
      map: {},
      map_2: {},
      hotMapList: [],
      changeWeek: '',
      isToday: true,
      setting: {
        first_refresh_time: 2,
        second_refresh_time: 5,
        third_refresh_time: 10,
      },
      // matinee:'',
      // evening:'',
      matinee_evening: [],
      hour: '',
      isYearSumShow: false,
      isGetUser: false,
      isGetRevenue: false,
      isIndex: false,
      city_name: '南昌',
      now_city_name: '南昌',
      cityComeData: '',
      oldComeIndex: 1,
      oldComeName: '老年主体',
      monthList: [],
      tradingNum: {},
      productMoneyList: [],
      pieColor: ['#6BB7FF', '#FF898A', '#FFC06B', '#986BFF', '#00aa00', '#550000',
        '#aaff00', '#ffff7f', '#aaaaff', '#aaffff', '#aaaa00', "#9A60B4",
        "#ea7ccc", "#1890FF", "#91CB74", "#FAC858", "#EE6666"],
      hotelData: {},
      businessNum: {},
      offlineRetailInfo: {},
      ote_type_sale_person_list: [],
      re_sex: {},
      total_tourists_num: 0,
      free_check_gate_record_num: 0,
      three_series: [],
      three_show: [],
      last_day: '',
      tableTurnoverRate: 0,
      deliciousFoodData: {},
      IotAppendDataCache: null,
      allShopIndex: 1,
      merchant_order_total_list: [],
      coefficient_data: 100,
      //舆情分析
      timeTrend: null,
      timeTrendData: {
        x: [], y: []
      },
      emotion: null,
      emotionData: [],
      mediaType: null,
      mediaTypeData: [],
      hotWeb: null,
      hotWebData: { x: [], y: [] },
      list: [],
      platform_type: {
        'XINWEN': '新闻',
        'APP': 'APP',
        'SHUZIBAO': '数字报',
        'WEIXIN': '微信公众号',
        'SHORT_VIDEO': '视频',
        'MICRO_BLOG': '微博客',
        'WENDA': '问答',
        'LUNTAN': '论坛'
      },
      emotionType: {
        '正面': '#67C23A',
        '中立': '#909399',
        '疑似负面': '#E6A23C',
        '负面': '#F56C6C'
      },
      timelineList: null,
      tendenciesList: [],
      tendenciesItem: {},
      isDetailLoading: false,
      actIndex: 0,
      isDetail: false
    };
  },
  computed: {
    taps() {
      return function (tapsStr) {
        if (tapsStr) {
          return tapsStr.split(' ').slice(0, 4)
        } else {
          return []
        }
      }
    },
    imageList() {
      return function (imagesStr) {
        if (imagesStr) {
          return imagesStr.split(',')
        } else {
          return []
        }
      }
    },
    isImg() {
      return function (text) {
        if (!text) return true
        return text.indexOf('<img') < 0
      }
    }
  },
  created() {
    if (sessionStorage.getItem('scenicId') === 'dsflksdjkfjlsdjlk1112312312111') {
      this.type_item.splice(3, 0, { label: '舆情分析', value: 3 })
    }
  },
  mounted() {
    if (!this.$route.query.id) {
      let id = sessionStorage.getItem('scenicId');
      this.$router.push({ path: '/', query: { id: id, token: store.state.token } })
      this.$router.go(0)
    }
    this.getToday();
    this.scenic_id = this.$route.query.id
    if(this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
      this.type_item = this.type_item.filter(item => item.value !== 2)
    }
    this.getCoefficientDataSetting()
    if (this.$route.query.date) {
      this.req_date = this.$route.query.date
      if (this.req_date && this.req_date != '') {
        var reDate = new Date(this.req_date)
        this.changeWeek = this.getWeek(reDate.getDay())
      }

    }
    if (this.$route.query.token) {
      this.$store.commit('setToken', this.$route.query.token);
    }
    if (this.$route.query.typeIndex !== undefined && this.$route.query.typeIndex !== null) {
      this.typeIndex = Number(this.$route.query.typeIndex)
    }
    // this.getSettingById();
    if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
      this.isToday = false;
    } else {
      let _this = this;
      //设置零点十分刷新
      let current = new Date();
      let next = new Date();
      next.setDate(current.getDate() + 1);
      next.setHours(0);
      next.setMinutes(10);
      next.setSeconds(0);
      setTimeout(doIT, next - current);
      function doIT() {
        _this.getGenderSchedule();
        _this.getHistoryData();
        _this.getRealTimeTraffic();
        _this.getPlaneFigure(1)
        setTimeout(doIT, 24 * 60 * 60 * 1000);
      }
    }
    if (this.typeIndex === 2 && this.isToday) {
      var today = new Date()
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24
      today.setTime(targetday_milliseconds) //注意，这行是关键代码
      var tYear = today.getFullYear()
      var tMonth = today.getMonth()
      var tDate = today.getDate()
      this.nowYear = tYear;
      tMonth = this.doHandleMonth(tMonth + 1)
      tDate = this.doHandleMonth(tDate)
      this.last_day = tYear + "-" + tMonth + "-" + tDate
    }
    
    this.bodyHeight = document.getElementById("bodys").offsetHeight + 54;
  },
  methods: {
    // 系数
    getCoefficientDataSetting() {
      getCoefficientDataSettingApi({ scenic_id: this.scenic_id }).then(res => {
        if (res.data.data.coefficient_data) {
          this.coefficient_data = res.data.data.coefficient_data
        }
        console.log(this.coefficient_data, '系数')
        this.getSettingById();
        if (this.typeIndex === 0) {
          this.type_index()
        } else if (this.typeIndex === 1) {
          this.type_user()
        } else if (this.typeIndex === 2) {
          this.type_revenue()
        } else if (this.typeIndex === 3) {
          console.log('this.nowDay', this.nowDay)
          this.getTimeTrend()
          this.handleGetList()
          this.tendenciesScroll()
        }
      })
    },
    prevImage(index) {
      this.actIndex--
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    nextImage(index) {
      this.actIndex++
      this.$refs.imagesList[index].style.marginLeft = `-${this.actIndex * 114}px`
    },
    isDataShow(state) {
      this.isYearSumShow = !state
    },
    type_index() {
      //调用接口
      this.getTouristsData();
      this.getGenderSchedule();
      this.getWeatherData();
      this.getOriginList();
      // this.getEnrollmentTime();
      this.getTicketNumberStatistics();
      this.getCurrentTrafficTrend();
      this.getRealTimeTraffic();
      this.getHistoryData();
      this.getTradingNum()
      this.getTouristAgencyType()

      let _this = this;
      setInterval(function () {
        _this.getTouristsData('change');
      }, 5000)
    },
    type_user() {
      this.getAnalysisMonth()
      this.getGenderSchedule()
      this.getTicketNumberStatistics();
      this.getOriginList()
      this.getWeatherData();
      this.getReData()
      // this.flight_coordinates(1)

    },
    type_revenue() {
      // this.changeTheDate('last')
      this.getTradingNum()
      this.getTouristAgencyType()
      this.getSalesNum()
      this.getBusinessNum()
      this.getBusinessList()
      this.getBigDataOfflineRetail()
      this.salesComparison()
      this.xcxGetHotelData()
      this.getDeliciousFoodData()
      this.getTradingNum_bar()
    },
    //根据ID获取景区大数据参数设置详情
    getSettingById() {
      getSettingByIdApi({
        scenic_id: this.scenic_id,
      }).then(res => {
        this.setting = res.data.data;
        if (this.req_date && this.req_date != '' && this.req_date != this.nowDay2) {
          this.isToday = false;
        } else {
          let _this = this;
          setInterval(function () {
            _this.getTouristsData();
            _this.getWeatherData(1);
            _this.getToday();
            _this.getWaitingIn()
          }, this.setting.first_refresh_time * 60 * 1000)
          setInterval(function () {
            _this.getTicketNumberStatistics();
          }, this.setting.second_refresh_time * 60 * 1000)
          setInterval(function () {
            _this.originIndex = 0;
            _this.getOriginList();
            _this.getGenderSchedule(1);

            _this.getCurrentTrafficTrend();

          }, this.setting.third_refresh_time * 60 * 1000)

        }
      })
    },
    //获取星期几
    getWeek(day) {
      switch (day) {
        case 0:
          return '周日'

        case 1:
          return '周一'

        case 2:
          return '周二'

        case 3:
          return '周三'

        case 4:
          return '周四'

        case 5:
          return '周五'

        case 6:
          return '周六'

      }
    },

    //切换类型
    focusPrice() {
      this.isShowType = true;
    },
    blurPrice() {
      this.isShowType = false;
    },
    changeOrigin(index) {
      this.originIndex = index;
      this.isShowType = false;
      this.getOriginList()
    },
    //点击头部切换类型
    typeChange(index) {
      this.typeIndex = index;
      const targetPath = index === 4 ? '/scenic_date_data' : '/'
      this.$router.push({ path: targetPath, query: { id: this.scenic_id, date: this.req_date, typeIndex: this.typeIndex, token: store.state.token } })
      this.$router.go(0)
    },
    // 获取是否需额外的IOT数据
    getIotAppendData(params) {
      if (this.IotAppendDataCache == null) {
        return iotSettingData(params).then(res => {
          this.IotAppendDataCache = res.data.data.mini_program_data || []
          return this.IotAppendDataCache || []
        })
      } else {
        return Promise.resolve(this.IotAppendDataCache)
      }
    },
    //获取实时游客数据
    getTouristsData(data) {
      realTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageRealData({ scenic_id: this.scenic_id, dates: this.req_date }).then(realRes => {
              res.data.data.total_tourists_num += realRes.data.data.total_tourists_num
              res.data.data.out_park_num += realRes.data.data.villager_out_num
              res.data.data.mouth_tourists_num += realRes.data.data.month_villager_num
              res.data.data.years_tourists_num += realRes.data.data.year_villager_num

              var in_tourists_num = res.data.data.total_tourists_num - res.data.data.out_park_num
              res.data.data.in_tourists_num = in_tourists_num > 0 ? in_tourists_num : 0
              return res
            })
          } else {
            return res
          }
        })
      }).then(res => {
        // if (data == 'change') {
        //   this.dateSum =  res.data.data.total_tourists_num.toString().split('');
        //   if(6-this.dateSum.length>0){
        //     var dateArr = []
        //     for(let i=0;i<6-this.dateSum.length;i++){
        //       dateArr.unshift('0')
        //     }
        //     this.dateSum.unshift(...dateArr)
        //   }
        //   return
        // }
        if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
          this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100 + 330000).toFixed(0).toString().split('');
        } else {
          this.yearSum = (res.data.data.years_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        }
        this.dateSum =  (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateInSum =  (res.data.data.in_tourists_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.dateOutSum = (res.data.data.out_park_num * this.coefficient_data / 100).toFixed(0).toString().split('');
        this.crowding = res.data.data.crowding.replace('%', '');
        this.ticket_of_data = res.data.data.ticket_of_data.replace('%', '');
        this.mouth_tourists_num = (res.data.data.mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.total_tourists_num = (res.data.data.total_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.free_check_gate_record_num = (res.data.data.free_check_gate_record_num * this.coefficient_data / 100).toFixed(0);
        //不够位数前面补零
        if (7 - this.yearSum.length > 0) {
          var yearArr = []
          for (let i = 0; i < 7 - this.yearSum.length; i++) {
            yearArr.unshift('0')
          }
          this.yearSum.unshift(...yearArr)
        }

        if (5 - this.dateInSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateInSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateInSum.unshift(...dateInArr)
        }
        if (5 - this.dateOutSum.length > 0) {
          var dateInArr = []
          for (let i = 0; i < 5 - this.dateOutSum.length; i++) {
            dateInArr.unshift('0')
          }
          this.dateOutSum.unshift(...dateInArr)
        }
        if (6 - this.dateSum.length > 0) {
          var dateArr = []
          for (let i = 0; i < 6 - this.dateSum.length; i++) {
            dateArr.unshift('0')
          }
          this.dateSum.unshift(...dateArr)
        }
        if (data != 'change') {
          this.getSaturation();
          this.getSellPer();
          this.getWaitingIn()
        }

      });

    },
    //获取历史游客数据
    getHistoryData() {
      var yesterday_tourists_num = 0
      var last_month_villager_num = 0
      var last_years_tourists_num = 0
      historyTouristsData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        yesterday_tourists_num = (res.data.data.yesterday_tourists_num * this.coefficient_data / 100).toFixed(0);
        this.last_mouth_tourists_num = (res.data.data.last_mouth_tourists_num * this.coefficient_data / 100).toFixed(0);
        if (this.scenic_id == 'e7bfd798d9ca461c9f37a4191d55edea') {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100 + 220000).toFixed(0);
        } else {
          last_years_tourists_num = (res.data.data.last_years_tourists_num * this.coefficient_data / 100).toFixed(0);
        }
      }).then(res => {
        this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          
          if (appendDataList.find(item => item === 'villager_in_out')) {
            console.log("??????", yesterday_tourists_num, last_month_villager_num, last_years_tourists_num)
            getIotScenicHistoryData({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              this.yesterday_tourists_num =  Number(yesterday_tourists_num) + Number((res.data.data.yesterday_villager_in_num * this.coefficient_data / 100).toFixed(0));
              this.last_month_villager_num = Number(last_month_villager_num) + Number((res.data.data.last_month_villager_num * this.coefficient_data / 100).toFixed(0));
              this.last_years_tourists_num = Number(last_years_tourists_num) + Number((res.data.data.last_year_villager_num * this.coefficient_data / 100).toFixed(0));
            })
          } else {
            this.yesterday_tourists_num = yesterday_tourists_num
            this.last_month_villager_num = last_month_villager_num
            this.last_years_tourists_num = last_years_tourists_num
          }
        })
      })
    },
    //获取游客性别及时间安排
    getGenderSchedule(i) {
      genderScheduleData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.gender = res.data.data.gender;
        this.schedule = res.data.data.schedule;
        // var total = res.data.data.matinee_evening.matinee + res.data.data.matinee_evening.evening
        // if(total>0){
        // 	this.matinee = (res.data.data.matinee_evening.matinee/total*100).toFixed(2)
        // 	this.evening = (res.data.data.matinee_evening.evening/total*100).toFixed(2)
        // }else{
        // 	this.matinee = 0;
        // 	this.evening = 0;
        // }
        this.matinee_evening = res.data.data.matinee_evening;
        if (res.data.data.men_total > 0) {
          this.menP = res.data.data.men_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.menP = 0 }
        if (res.data.data.women_total > 0) {
          this.womenP = res.data.data.women_total / (res.data.data.men_total + res.data.data.women_total) * 100
        } else { this.womenP = 0 }
        this.getGender();
        if (i == 1) {
          return false
        } else {
          this.getTime();
          this.getMatineeEvening();
        }

      })
    },
    //早晚场次
    getMatineeEvening() {
      var series = [];
      series.push({ value: this.matinee_evening[0].replace('%', ''), name: '日游场' })
      series.push({ value: this.matinee_evening[1].replace('%', ''), name: '夜游场' })
      series.push({ value: this.matinee_evening[2].replace('%', ''), name: '日转夜' })
      series.push({ value: this.matinee_evening[3].replace('%', ''), name: '过夜' })
      series.push({ value: this.matinee_evening[4].replace('%', ''), name: '其他' })

      var MatineeEvening_1 = this.echarts.init(document.getElementById('matinee_evening_1'));
      var option = {
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01'],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + '%'
          },
        }
      }

      MatineeEvening_1.setOption(option)
    },
    //获取时间
    getToday() {
      var today = new Date();
      var year = today.getFullYear();
      var month = today.getMonth() > 8 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
      var date = today.getDate() > 9 ? today.getDate() : '0' + today.getDate();
      this.hour = today.getHours() > 9 ? today.getHours() : '0' + today.getHours();
      var min = today.getMinutes() > 9 ? today.getMinutes() : '0' + today.getMinutes();
      var second = today.getSeconds() > 9 ? today.getSeconds() : '0' + today.getSeconds();
      this.nowDay = year + '/' + month + '/' + date;
      this.nowYear = year;
      this.nowDay2 = year + '-' + month + '-' + date;
      this.nowTime = this.hour + ":" + min + ":" + second;
      this.week = this.getWeek(today.getDay())
    },
    //获取天气
    getWeatherData(i) {
      weatherData({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        // this.temperature = res.data.data.weather.temperature;
        // this.winddirection = res.data.data.weather.winddirection;
        // this.windpower = res.data.data.weather.windpower;
        this.weather = res.data.data.weather;
        if (i && i != undefined) {
          this.getToday();
          return
        } else {
          if (this.typeIndex === 0) {
            this.getPlaneFigure();
          } else if (this.typeIndex === 1) {
            this.getPlaneFigure();
          }
        }
      })
    },
    //获取飞机图数据
    getPlaneFigure(i) {
      planeFigure({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var to = { lat: parseFloat(this.weather.lat), lng: parseFloat(this.weather.lng) }
        var arr = [];
        fly = [];
        this.hotMapList = []

        arcData = [];
        heatData = [];
        for (var j = 0; j < res.data.data.lists.length; j++) {
          var fly = res.data.data.lists[j]
          for (var city in fly) {
            this.hotMapList.push({ name: city, value: fly[city].total })
            arcData.push({ to: to, from: { lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude) }, count: fly[city].total })
            heatData.push({ lat: parseFloat(fly[city].latitude), lng: parseFloat(fly[city].longitude), count: fly[city].total })
          }

        }
        // arcData = res.data.data.dicts
        this.flight_coordinates(i)
      })

    },
    //获取游客入园时间统计
    // getEnrollmentTime(){
    //   enrollmentTimeData({
    //     scenic_id:2,
    //     dates:'2021-07-17'
    //   }).then(res => {
    //     this.touristsData = res.data.data;
    //     this.getInTime()
    //   })
    // },
    //获取客源地(省份/城市)数据
    getOriginList() {
      originList({
        scenic_id: this.scenic_id,
        dates: this.req_date,
        sort_type: this.originIndex + 1,
        data_type: 2
      }).then(res => {
        this.origin_list_dict = res.data.data.origin_list_dict
        this.getAddress();
      })
    },
    //游客进出园时间分析
    getCurrentTrafficTrend() {
      currentTrafficTrend({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        var obj = res.data.data.current_traffic_trend
        // this.current_traffic_trend.categories = [];
        // this.current_traffic_trend.series = [];
        this.$set(this.current_traffic_trend, 'categories', []);
        this.$set(this.current_traffic_trend, 'series', []);
        return obj
      }).then(current_traffic_trend => {
        return this.getIotAppendData({ scenic_biz: this.scenic_id, }).then(appendDataList => {
          if (appendDataList.find(item => item === 'villager_in_out')) {
            return getIotScenicVillageTrend({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
              res.data.data.villager_trend.series.forEach(item => { current_traffic_trend.series.push(item) })
              return current_traffic_trend
            })
          } else {
            return current_traffic_trend
          }
        })
      }).then(current_traffic_trend => {
        if (!this.req_date || this.req_date == '' || this.req_date == this.nowDay2) {
          for (var i = 0; i < current_traffic_trend.categories.length; i++) {
            if (current_traffic_trend.categories[i] <= (parseInt(this.hour) + 1)) {
              this.current_traffic_trend.categories.push(current_traffic_trend.categories[i])
            } else {
              break
            }
          }
          for (var j = 0; j < current_traffic_trend.series.length; j++) {
            this.current_traffic_trend.series.push({ name: current_traffic_trend.series[j].name, data: current_traffic_trend.series[j].data.slice(0, this.current_traffic_trend.categories.length) })
          }
        } else {
          this.current_traffic_trend = current_traffic_trend
        }
        for (var i=0;i<this.current_traffic_trend.categories.length;i++) {
          var series = this.current_traffic_trend.series
          series[0].data[i] = (series[0].data[i] * this.coefficient_data / 100).toFixed(0)
          series[1].data[i] = (series[1].data[i] * this.coefficient_data / 100).toFixed(0)
          series[2].data[i] = (series[2].data[i] * this.coefficient_data / 100).toFixed(0)
          series[3].data[i] = (series[3].data[i] * this.coefficient_data / 100).toFixed(0)
          series[4].data[i] = (series[4].data[i] * this.coefficient_data / 100).toFixed(0)
          series[5].data[i] = (series[5].data[i] * this.coefficient_data / 100).toFixed(0)
          series[6].data[i] = (series[6].data[i] * this.coefficient_data / 100).toFixed(0)
          if (series[7]) {
            series[7].data[i] = (series[7].data[i] * this.coefficient_data / 100).toFixed(0)
          }
          if (series[8]) {
            series[8].data[i] = (series[8].data[i] * this.coefficient_data / 100).toFixed(0)
          }
        }
        this.getInOrOut();
        this.getInTime()
        this.showPeakLine(this.current_traffic_trend)
      })
    },
    //游客客流分析
    getRealTimeTraffic() {
      realTimeTraffic({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.real_time_traffic_list = res.data.data.real_time_traffic_list
        this.getTouristLine();
      })
    },
    //入园游客类型统计
    getTicketNumberStatistics() {
      ticketNumberStatistics({
        scenic_id: this.scenic_id,
        dates: this.req_date
      }).then(res => {
        this.ticket_number_statistics = res.data.data.ticket_number_statistics
        this.getTouristType()
      })
    },
    //在园游客占园区可容纳占比图表
    getSaturation() {

      var saturation = this.echarts.init(document.getElementById('saturation'));
      var crowding = this.crowding.toString();
      let _this = this;
      saturation.setOption({
        title: {
          text: (this.crowding * this.coefficient_data / 100).toFixed(2) + '%',
          textStyle: {
            color: "#fff",
            fontWeight: 400
          },
          subtext: "在园游客\n饱和度",
          subtextStyle: {
            width: 10,
            color: '#fff',
            lineHeight: 15
          },   //副标题样式
          left: 'center',
          top: '30px',
          itemGap: 6,
        },
        series: [
          {
            type: 'pie',
            radius: [55, 42],
            silent: true,
            color: ["rgba(0,0,0,0)"],
            data: [
              {
                value: this.crowding,
                itemStyle: {
                  normal: {//颜色渐变
                    color: new _this.echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        { offset: 0, color: '#7917f8' },
                        { offset: 1, color: '#e223fe' }
                      ]
                    )
                  }
                }
              },
              {
                value: 100 - this.crowding,

              },
            ],
            label: {
              show: false
            },
          },
          // {
          //   color:['#000'],
          //   type:'pie',
          //   radius: [40, 40],
          //   data:[
          //     {value:100}
          //   ]
          // }
        ]
      })
    },
    //当日售票占比图表
    getSellPer() {
      var sellPer = this.echarts.init(document.getElementById('sellPer'));
      let _this = this;
      sellPer.setOption({
        title: {
          text: (this.ticket_of_data * this.coefficient_data / 100).toFixed(2) + "%",
          textStyle: {
            color: "#fff",
            fontWeight: 400
          },
          subtext: "售票人数\n预警",
          subtextStyle: {
            width: 10,
            color: '#fff',
            lineHeight: 15
          },   //副标题样式
          left: 'center',
          top: '30px',
          itemGap: 6,
        },

        series: [
          {
            type: 'pie',
            silent: true,
            radius: [55, 42],
            color: ["rgba(0,0,0,0)"],
            data: [
              {
                value: this.ticket_of_data,
                itemStyle: {
                  normal: {//颜色渐变
                    color: new _this.echarts.graphic.LinearGradient(
                      0, 0, 0, 1,
                      [
                        { offset: 0, color: '#7744ff' },
                        { offset: 1, color: '#03a3ff' }
                      ]
                    )
                  }
                }
              },
              { value: 100 - this.ticket_of_data },
            ],
            label: {
              show: false
            },
          }
        ]
      })

    },
    //性别占比图表
    getGender() {
      var xAxisArr = [];
      var yAxisMen = [];
      var yAxisWomen = [];
      for (let i = this.gender.men.length - 1; i >= 0; i--) {
        // var name;
        // if(this.gender.men[i].name.indexOf('+')==-1){
        //   name = this.gender.men[i].name +'岁'
        // }else{
        //   name = this.gender.men[i].name.replace('+','岁以上')
        // }
        xAxisArr.push(this.gender.men[i].name);
        yAxisMen.push(this.gender.men[i].data);
        yAxisWomen.push(this.gender.women[i].data);
      }
      var yAxisArr = [
        { type: 'bar', name: '男', data: yAxisMen },
        { type: 'bar', name: '女', data: yAxisWomen },
      ]
      this.gender.men.type = 'bar';
      this.gender.men.name = '男';
      this.gender.women.type = 'bar';
      this.gender.women.name = '女'
      // var gender = this.echarts.init(document.getElementById('gender'));
      var gender_1 = this.echarts.init(document.getElementById('gender_1'));
      var option = {
        grid: {
          top: "10%",
          left: "14%",
          right: "4.5%",
          bottom: "25%"
        },
        tooltip: {},
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 7     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          },
          data: xAxisArr
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 8,      //更改坐标轴文字大小
            },
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        color: ['#023aff', '#991bfa'],
        barWidth: 6,
        series: yAxisArr
      }
      // gender.setOption(option)
      gender_1.setOption(option)
    },
    //时间占比图表
    getTime() {
      var yAxisArr = [];
      for (let i = 0; i < this.schedule.value.length; i++) {
        yAxisArr.push(this.schedule.value[i].replace('%', ''))
      }
      // var time = this.echarts.init(document.getElementById('time'));
      var time_1 = this.echarts.init(document.getElementById('time_1'));
      var option = {
        grid: {
          top: "10%",
          left: "13%",
          right: "4%",
          bottom: "25%"
        },
        tooltip: {
          formatter: function (params) {
            return params.data + '%'
          }
        },
        xAxis: {
          data: this.schedule.label,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 6      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            show: true,
            formatter: '{value}%',
            textStyle: {
              color: '#8184a2',
              fontSize: 8      //更改坐标轴文字大小
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: yAxisArr,
            barWidth: 10
          },
        ]
      }
      // time.setOption(option)
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.grid.right = '6%'
      option_1.grid.left = '12%'
      option_1.xAxis.axisLabel.textStyle.fontSize = 7
      option_1.tooltip.formatter = function (params) {
        return params.data + '%'
      }
      time_1.setOption(option_1)
    },
    //入园游客类型图表
    getTouristType() {
      // 每项顺序['散客票数','团队票数',"贵宾接待",'单位VIP','本地游客']
      var qianjing = [
        this.ticket_number_statistics.wx_mini_pro_member_num,
        this.ticket_number_statistics.wx_mini_pro_agency_num,
        this.ticket_number_statistics.wx_mini_pro_vip_num,
        this.ticket_number_statistics.wx_mini_pro_enterprise_vip_num
      ]

      var ota = [this.ticket_number_statistics.ota_num, 0, 0, 0, 0]
      var unLine = [
        this.ticket_number_statistics.member,
        this.ticket_number_statistics.agency,
        this.ticket_number_statistics.vip,
        this.ticket_number_statistics.enterprise_vip,
        this.ticket_number_statistics.free_check_gate_record_num
      ]
      // var touristType = this.echarts.init(document.getElementById('touristType'));
      var touristType_1 = this.echarts.init(document.getElementById('touristType_1'));
      var option = {
        grid: {
          top: "5%",
          left: "15%",
          right: "4%",
          bottom: "25%"
        },
        legend: {
          show: true,
          y: 'bottom',
          icon: "circle",
          itemWidth: 5,
          itemHeight: 5,
          itemGap: 30,
          textStyle: {  // 图例文字的样式
            color: '#fff',
          },
        },
        tooltip: {},
        xAxis: {
          data: ['散客票数', '团队票数', "贵宾接待", '单位VIP', '本地游客'],
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 9      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        yAxis: {
          splitNumber: 4,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 12     //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            name: '线下窗口',
            color: '#023aff',
            data: unLine,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: '牵景平台',
            color: '#01f1e3',
            data: qianjing,
            barWidth: 10,
            stack: 'x'
          },
          {
            type: 'bar',
            name: 'OTA',
            color: '#991bfa',
            data: ota,
            barWidth: 10,
            stack: 'x'
          }
        ]
      }
      // touristType.setOption(option)
      touristType_1.setOption(option)
    },
    //客源地统计图表
    getAddress() {
      var xAxisArr = [];
      var max = Math.max.apply(null, this.origin_list_dict.area_total_list);
      var divisor = max / 4;
      var maxmax = max + max / 3;
      var area_total_list = []
      var area_member_list = []
      var area_agency_list = []
      for (let i = 0; i < this.origin_list_dict.area_total_list.length; i++) {
        area_total_list.push(this.origin_list_dict.area_total_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_member_list.length; i++) {
        area_member_list.push(this.origin_list_dict.area_member_list[i] + divisor)
      }
      for (let i = 0; i < this.origin_list_dict.area_agency_list.length; i++) {
        area_agency_list.push(this.origin_list_dict.area_agency_list[i] + divisor)
      }
      // var address = this.echarts.init(document.getElementById('address'));
      var address_1 = this.echarts.init(document.getElementById('address_1'));
      option = {
        color: ['#01f1e3', '#023aff', '#bb63ff'],
        legend: {
          show: true,
          // y: '10px',    //延Y轴居中
          bottom: 0,
          left: 10,
          // orient: 'vertical',
          align: 'left',
          itemWidth: 10,
          itemHeight: 2,
          textStyle: {
            color: '#fff'
          }
        },
        radar: {
          splitNumber: 1,
          radius: 60,
          nameGap: 6,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          center: ['50%', '40%'],
          indicator: [
            { name: '东北', max: maxmax },
            { name: '华东', max: maxmax },
            { name: '华北', max: maxmax },
            { name: '华中', max: maxmax },
            { name: '西北', max: maxmax },
            { name: '西南', max: maxmax },
            { name: '华南', max: maxmax },
          ],
          splitLine: {
            show: true,
            lineStyle: {
              width: 0.5
            }
          },
          axisLine: {
            lineStyle: {
              width: 0.5
            }
          },
          splitArea: {
            show: false
          },

        },
        tooltip: {
          formatter: function (params) {
            var arr = []
            var _address = ['东北', '华东', '华北', '华中', '西北', '西南', '华南']
            for (let i = 0; i < params.value.length; i++) {
              arr.push(_address[i] + ':' + (params.value[i] - divisor) + ' ')
            }
            return params.name + '：[ ' + arr + ' ]'
          }
        },
        series: [

          {
            symbol: 'none',
            type: 'radar',
            data: [
              {
                value: area_total_list,
                name: '总数',
                lineStyle: { // 单项线条样式。

                  normal: {

                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,

                  }
                },
              }
            ]
          },

          {
            symbol: 'none',
            type: 'radar',
            symbol: "none",
            data: [
              {
                value: area_member_list,
                name: '散客',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度
                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明度

                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_member_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
          {
            symbol: 'none',
            type: 'radar',
            symbol: "none",
            data: [
              {
                value: area_agency_list,
                name: '团队',
                lineStyle: { // 单项线条样式。
                  normal: {
                    opacity: 0.8, // 图形透明度

                  }
                },
                areaStyle: {
                  normal: {
                    type: 'default',
                    opacity: 0.6, // 图表中各个图区域的透明
                  }
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      // return this.origin_list_dict.area_agency_list[params.dataIndex] ;
                      return params.value - divisor
                    }
                  }
                },
              }
            ]
          },
        ]
      }
      var option_1 = JSON.parse(JSON.stringify(option))
      option_1.tooltip.position = 'right'
      // address.setOption(option);
      address_1.setOption(option_1);
      // var addressBar = this.echarts.init(document.getElementById('addressBar'));
      var addressBar_1 = this.echarts.init(document.getElementById('addressBar_1'));
      var newAddressArr = [];
      for (var i = this.origin_list_dict.o_total_list.length - 1; i >= 0; i--) {
        newAddressArr[newAddressArr.length] = this.origin_list_dict.o_total_list[i];
      }
      
      var newAddressName = [];
      for (var i = this.origin_list_dict.o_address_list.length - 1; i >= 0; i--) {
        newAddressName[newAddressName.length] = this.origin_list_dict.o_address_list[i];
      }
      var option = {
        grid: {
          top: "0",
          left: "0",
          right: "0",
          bottom: "0"
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function (params) {
            return params.value;
          },
        },
        xAxis: {
          splitLine: {
            show: false
          }
        },
        yAxis: {
          data: newAddressName
        },

        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: newAddressArr,
            barWidth: 10
          },
        ]
      }
      // addressBar.setOption(option)
      addressBar_1.setOption(option)
    },
    //获取游客客流分析
    getTouristLine() {
      var xAxisArr = [];
      var yAxisArr = [];
      for (var i = this.real_time_traffic_list.time_list.length - 1; i >= 0; i--) {
        xAxisArr.push(this.real_time_traffic_list.time_list[i])
      }
      for (var i = this.real_time_traffic_list.data_list.length - 1; i >= 0; i--) {
        yAxisArr.push((this.real_time_traffic_list.data_list[i] * this.coefficient_data / 100).toFixed(0))
      }
      var touristLine = this.echarts.init(document.getElementById('touristLine'));
      touristLine.setOption({
        grid: {
          top: "5%",
          left: "16%",
          right: "6%",
          bottom: "16%"
        },
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: xAxisArr
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 5,
        },
        tooltip: {},
        series: [
          {
            data: yAxisArr,
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            smooth: true,
            lineStyle: {
              color: {
                type: 'linear',
                x: 1,
                y: 0,
                x2: 0,
                y2: 0,
                colorStops: [{
                  offset: 0, color: '#7D40FF' // 0% 处的颜色
                }, {
                  offset: 1, color: '#02A4FF' // 100% 处的颜色
                }],
              }
            },
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [{
                    offset: 0, color: '#7D40FF' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#02A4FF' // 100% 处的颜色
                  }],
                },
                borderColor: '#fff',
                borderWidth: 2,
              }

            }
          }
        ]
      });
    },
    //获取游客进出园时间
    getInOrOut() {
      var inOrOut = this.echarts.init(document.getElementById('inOrOut'));

      var f = (e, i, t) => Number(e) + Number(t[i])
      inOrOut.setOption({
        grid: {
          top: "20%",
          left: "12%",
          right: "5%",
          bottom: "16%"
        },
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#01F1E3' // 0% 处的颜色
            }, {
              offset: 1, color: '#4DA1FF' // 100% 处的颜色
            }],
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#02A4FF' // 0% 处的颜色
            }, {
              offset: 1, color: '#7D40FF' // 100% 处的颜色
            }],
          }
        ],
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          itemWidth: 9,
          itemHeight: 9,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          }
        },

        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: this.current_traffic_trend.categories,

        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 5,
        },
        lineStyle: {
          color: '#fff',
        },
        tooltip: {},
        series: [
          {
            data: (this.current_traffic_trend.series[7] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[7].data)) :
              this.current_traffic_trend.series[0].data),
            type: 'line',
            name: '进园',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 0.5
                },
                borderColor: '#fff',
                borderWidth: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#01F1E3' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#4DA1FF' // 100% 处的颜色
                  }],
                }
              },
            },
            areaStyle: {}
          },
          {
            data: (this.current_traffic_trend.series[8] ?
              this.current_traffic_trend.series[0].data.map((e, i) => f(e, i, this.current_traffic_trend.series[8].data)) :
              this.current_traffic_trend.series[1].data),
            type: 'line',
            name: '出园',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 0.5
                },
                borderColor: '#fff',
                borderWidth: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: '#02A4FF' // 0% 处的颜色
                  }, {
                    offset: 1, color: '#7D40FF' // 100% 处的颜色
                  }],
                }
              }
            },
            areaStyle: {}
          },
        ]
      })
    },
    //游客入园时间图表
    getInTime() {
      var inTime = this.echarts.init(document.getElementById('inTime'));
      // var xAxisArr = [];
      // for(let i=this.touristsData.dates_list.length-1;i>=0;i--){
      //   xAxisArr.push(this.touristsData.dates_list[i].slice(5))
      // }
      // var yAxisArr = []
      // for(var name in this.touristsData.tourists_list){
      //   yAxisArr.push({type:'line',name:name,data:[]});
      // }
      // for(let i=0;i<yAxisArr.length;i++){
      //   for(let j=0;j<this.touristsData.tourists_list[yAxisArr[i].name].length;j++){
      //     yAxisArr[i].data.unshift(this.touristsData.tourists_list[yAxisArr[i].name][j])
      //   }
      // }

      var iotAppendData = []
      var dataItem = JSON.stringify({
        type: 'line', areaStyle: {}, smooth: true,
        symbol: 'circle', symbolSize: 6,
        data: [],
        name: '',
        itemStyle: { normal: { lineStyle: { width: 0.5 }, borderColor: '#fff', borderWidth: 2 } }
      })
      this.current_traffic_trend.series[9] && iotAppendData.push({ ...JSON.parse(dataItem), data: this.current_traffic_trend.series[9].data, name: this.current_traffic_trend.series[9].name })
      inTime.setOption({
        grid: {
          top: "20%",
          left: "12%",
          right: "5%",
          bottom: "16%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        tooltip: {},
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: this.current_traffic_trend.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 4,
        },
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
        series: [{
          data: this.current_traffic_trend.series[2].data,
          type: 'line',
          smooth: true,
          name: '散客',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#01F1E3' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#4DA1FF' // 100% 处的颜色
              //   }],
              // }
            },
          },
          areaStyle: {}
        },
        {
          data: this.current_traffic_trend.series[3].data,
          type: 'line',
          smooth: true,
          name: '团队',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        },
        {
          data: this.current_traffic_trend.series[4].data,
          type: 'line',
          smooth: true,
          name: '企业',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        },
        {
          data: this.current_traffic_trend.series[5].data,
          type: 'line',
          smooth: true,
          name: '贵宾',
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
              // color:{
              //   type: 'linear',
              //   x: 0,
              //   y: 0,
              //   x2: 0,
              //   y2: 1,
              //   colorStops: [{
              //       offset: 0, color: '#02A4FF' // 0% 处的颜色
              //   }, {
              //       offset: 1, color: '#7D40FF' // 100% 处的颜色
              //   }],
              // }
            }
          },
          areaStyle: {}
        }].concat(iotAppendData)
      });
    },
    convertData(data, geoCoordMap) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i];
        var fromCoord = geoCoordMap[dataItem[0].name];
        var toCoord = geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [toCoord, fromCoord]
          });
        }
      }
      return res;
    },
    // 飞机图或热力图
    flight_coordinates(i) {
      // var center = new TMap.LatLng(29.320494, 118.119699);
      var data = arcData.slice(0, 50);
      if (i == 1) {
        if (this.flightMap) {
          this.flightMap.remove();
        }
      } else {
        var center = new TMap.LatLng(parseFloat(this.weather.lat) + this.setting.lat_offset, parseFloat(this.weather.lng) + this.setting.lng_offset);
        //初始化地图
        this.map = new TMap.Map("migrateMap", {
          zoom: this.setting.map_show,//设置地图缩放级别
          pitch: 30,
          center: center,//设置地图中心点坐标
          mapStyleId: "style3", //个性化样式
          showControl: false, //禁止所有控件
          baseMap: {
            type: "vector",
            features: ["base", "building3d", "point"], // 隐藏矢量文字
          },
        });

      }
      //初始化弧线图并添加至map图层
      if (this.typeIndex == 0) {
        this.flightMap = new TMap.visualization.Arc({
          pickStyle: function (arcLine) { // 样式映射函数
            return {
              color: "rgba(29,211,253,0.3)",
              animateColor: "rgba(255, 255, 255, 1)",
              width: 2
            };
          },
          mode: 'vertical' // 弧线平面与地平面垂直
        }).addTo(this.map).setData(data);//设置数据
      } else if (this.typeIndex == 1) {
        this.flightMap = new TMap.visualization.Heat({
          max: 600, // 热力最强阈值
          min: 0, // 热力最弱阈值
          height: 6, // 峰值高度
          radius: 36, // 最大辐射半径
        }).addTo(this.map)
        this.flightMap.setOpacity(0.8); // 设置透明度变化范围
        var gradient = this.flightMap.getGradientColor(); // 获取渐变色
        gradient.stops[0.1] = "#fff";
        gradient.stops[0.3] = '#5589f2'
        gradient.stops[0.6] = '#E9AB1D'
        gradient.stops[0.8] = '#e53f31'
        gradient.stops[0.99] = '#b84b41'
        gradient.stops[1.0] = '#652074'
        this.flightMap.setGradientColor(gradient); // 设置渐变色
        this.flightMap.setData(heatData);//设置数据
      }
    },
    changeTheDate(day) {
      if (day == 0) {
        var date = '';
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      } else {
        if (this.req_date != null) {
          var today = new Date(this.req_date)
        } else {
          var today = new Date()
        }
        var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
        today.setTime(targetday_milliseconds) //注意，这行是关键代码
        var tYear = today.getFullYear()
        var tMonth = today.getMonth()
        var tDate = today.getDate()
        this.nowYear = tYear;
        tMonth = this.doHandleMonth(tMonth + 1)
        tDate = this.doHandleMonth(tDate)
        var date = tYear + "-" + tMonth + "-" + tDate
        this.$router.push({ path: '/', query: { id: this.scenic_id, date: date, typeIndex: this.typeIndex, token: store.state.token } })
        this.$router.go(0)
      }

    },
    doHandleMonth(month) {
      var m = month
      if (month.toString().length == 1) {
        m = "0" + month
      }
      return m
    },
    // 获取客源月份
    getAnalysisMonth() {
      getAnalysisMonthApi({
        scenic_id: this.scenic_id
      }).then(res => {
        for (var month in res.data.data) {
          this.monthList = res.data.data[month]
          break
        }
        this.getCityCome()
        this.getOldCome()
      })
    },
    // 获取城市客源结构分析
    getCityCome() {
      getDataCustomerSourceMarketApi({
        scenic_id: this.scenic_id,
        city_name: this.city_name,
        month: this.monthList[0]
      }).then(res => {
        this.now_city_name = this.city_name
        this.cityComeData = res.data.data
        var categories = []
        var series = []
        var series_num = []
        var five_type = 'zongti_list'
        var five_num_type = 'zongti_list_num'
        for (let i = 0; i < this.monthList[1].length; i++) {
          categories.push(this.monthList[1][i] + '月')
        }
        series.push({ name: '60+', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][0] })
        series.push({ name: '50-60', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][1] })
        series.push({ name: '40-50', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][2] })
        series.push({ name: '30-40', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][3] })
        series.push({ name: '18-30', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][4] })
        series.push({ name: '18-', type: 'line', stack: 'Total', areaStyle: {}, emphasis: { focus: 'series' }, data: this.cityComeData[five_type][5] })
        // for(let i=0;i<series_num.length;i++){
        // 	series_num[i].data.unshift(series_num[i].data[11])
        // 	series_num[i].data.splice(12,1)
        // }
        var cityCome = this.echarts.init(document.getElementById('cityCome'));
        var option = {
          legend: {
            // Try 'horizontal'
            orient: 'horizontal',
            right: 'center',
            width: 325,
            bottom: 0
          },
          tooltip: {
            trigger: 'axis',
            position: function (point, params, dom, rect, size) {
              return [point[0] - 100, '10%']  //返回x、y（横向、纵向）两个点的位置
            },
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#1e5671'
              }
            },
            textStyle: {
              fontSize: 10,
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            top: '18%',
            left: '3%',
            right: '3%',
            bottom: '23%',
            containLabel: true
          },
          legend: {
            textStyle: {
              color: "#ffffff"
            },
            bottom: 'bottom'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: categories,
              minorTick: {
                splitNumber: 12
              },
              axisLabel: {
                fontSize: 9,
                color: '#ffffff'
              }
            }
          ],
          yAxis: [
            {
              max: 1,
              type: 'value',
              axisLabel: {
                formatter: function (value, index) {
                  return (value * 100).toFixed(0) + '%';
                },
                color: '#ffffff'
              }
            }
          ],
          series: series
        }
        cityCome.setOption(option)
      })
    },
    getOldCome() {
      getDataMainSourceMarketApi({
        scenic_id: this.scenic_id,
        data_type: 1,
        month: this.monthList[0]
      }).then(res => {
        this.oldComeData = res.data.data
        this.drawOldCome(this.oldComeIndex)
      })
    },
    drawOldCome(i) {
      this.oldComeIndex = i
      if (this.oldComeIndex === 1) {
        this.oldComeName = '老年主体'
      } else if (this.oldComeIndex === 2) {
        this.oldComeName = '中年主体'
      } else if (this.oldComeIndex === 3) {
        this.oldComeName = '青少年主体'
      } else if (this.oldComeIndex === 4) {
        this.oldComeName = '亲子主体'
      } else if (this.oldComeIndex === 5) {
        this.oldComeName = '均衡结构'
      }
      var max = ''
      var categories = []
      var series = []
      var five_type = '总体'
      var big_type = ''
      if (this.oldComeIndex == 1) {
        big_type = 'old_age_list'
      } else if (this.oldComeIndex == 2) {
        big_type = 'middle_age_list'
      } else if (this.oldComeIndex == 3) {
        big_type = 'teenagers_list'
      } else if (this.oldComeIndex == 4) {
        big_type = 'parenting_list'
      } else if (this.oldComeIndex == 5) {
        big_type = 'equilibrium_list'
      }
      for (let i = 0; i < this.oldComeData[big_type][five_type][0].slice(0, 10).length; i++) {
        categories.push(this.oldComeData[big_type][five_type][0][i].substring(0, 2))
        series.push((this.oldComeData[big_type][five_type][2][i] * 100).toFixed(2))
      }
      if (series.length == 0) {
        series.push()
        categories.push('暂无数据')
        max = 1
      }
      var oldCome = this.echarts.init(document.getElementById('oldCome'));
      var option = {
        grid: {
          top: "10%",
          left: "13%",
          right: "3%",
          bottom: "10%"
        },
        tooltip: {
          formatter: function (params) {
            return params.data + '%'
          }
        },
        xAxis: {
          data: categories,
          axisLabel: {

            show: true,
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          axisLabel: {
            formatter: '{value} %',
            show: true,
            textStyle: {
              color: '#8184a2',
              fontSize: 10,      //更改坐标轴文字大小

              color: '#ffffff',
            }
          },
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          }
        },
        series: [
          {
            type: 'bar',
            color: '#023aff',
            data: series,
            barWidth: 13
          },
        ]
      }
      oldCome.setOption(option)
    },
    getTradingNum_bar() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTradingNumApi(params).then(res => {
        var categories = []
        var series_data = []

        res.data.data.ote_type_sale_volume_list.slice(0, 10).forEach(item => {
          categories.push(item[0])
          series_data.push(item[1])
        })
        categories.reverse()
        series_data.reverse()
        var obj = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            // boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 8     //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var OTArank = this.echarts.init(document.getElementById('OTArank'));
        OTArank.setOption(obj)
      })
    },
    //今日交易总额
    getTradingNum() {
      var OTArank = this.echarts.init(document.getElementById('OTArank'));
      var params = {}
      if (this.typeIndex === 2 && this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.req_date }
      }

      getTradingNumApi(params).then(res => {
        if (this.typeIndex === 0) {
          this.ote_type_sale_person_list = res.data.data.ote_type_sale_person_list
          this.showOtaPie(this.ote_type_sale_person_list)
          return
        }
        this.tradingNum = res.data.data;
      })
    },
    // ota饼图
    showOtaPie(data) {
      var series = [];
      for (let i = 0; i < data.length; i++) {
        series.push({value: (data[i][1] * this.coefficient_data / 100).toFixed(0), name:data[i][0]})
      }
      var ota_pie_1 = this.echarts.init(document.getElementById('ota_pie_1'));
      var option = {
        color: this.pieColor,
        padding: [0, 0, 0, 0],
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":<br/>" + params.data.value + '人'
          },
        },
        legend: {
          show: false,
        },
      }
      ota_pie_1.setOption(option)
    },
    // 旅行社交易排名
    getTouristAgencyType() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getTouristAgencyType(params).then(res => {
        let list = []
        if (this.typeIndex === 0) {
          list = res.data.data.tourist_agency_type_sale_person_list
        } else {
          list = res.data.data.tourist_agency_type_sale_volume_list
        }
        let categories = []
        let series_data = []
        list.slice(0, 10).forEach(item => {
          categories.push(item[0].tourist_agency__name)
          series_data.push((item[1] * this.coefficient_data / 100).toFixed(0))
        })
        categories.reverse()
        series_data.reverse()
        var res = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '0',
            right: '10%',
            bottom: '6%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 8      //更改坐标轴文字大小
              }
            },
          },
          yAxis: {
            type: 'category',
            data: categories,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var res_1 = JSON.parse(JSON.stringify(res))
        res_1.yAxis.axisLabel.formatter = function (value) {
          return value.slice(0, 5);
        }
        res_1.grid.top = '1%'
        res_1.grid.bottom = '0'
        res.xAxis.splitNumber = 3
        if (this.typeIndex === 0) {
          var travelPerson = this.echarts.init(document.getElementById('travelPerson'));
          travelPerson.setOption(res_1)
        } else {
          var travelRank = this.echarts.init(document.getElementById('travelRank'));
          travelRank.setOption(res)
        }

      })
    },
    // 销售数量占比、销售金额占比
    getSalesNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getSalesNumApi(params).then(res => {
        this.showTicketProductMoney(res.data.data.ticket_product_money)
      })
    },
    // 销售金额占比(产品)
    showTicketProductMoney(data) {
      var total = 0;
      var series = [];
      var productMoney = this.echarts.init(document.getElementById('productMoney'));
      for (let j = 0; j < data.value.length; j++) {
        total += data.value[j]
      }
      for (let i = 0; i < data.label.length; i++) {
        this.productMoneyList.push({
          name: data.label[i],
          data: (data.value[i] / total * 100).toFixed(2) + '%'
        })
        series.push({
          name: data.label[i],
          value: data.value[i]
        })
      }
      var option = {
        color: this.pieColor,
        series: [
          {
            type: 'pie',
            data: series,
            radius: '80%',
            label: {
              show: false
            },
          }
        ],
        tooltip: {
          trigger: 'item'
        },

      }
      productMoney.setOption(option)
    },
    // 获取复游
    getReData() {
      getDataRepurchaseAnalysisApi({
        scenic_id: this.scenic_id
      }).then(res => {
        this.re_sex = { woman: res.data.data.women_num * 100, man: res.data.data.men_num * 100 }
        var chartData = res.data.data.frequency_list
        var series = []
        var re_pie = this.echarts.init(document.getElementById('re_pie'));
        series.push({
          name: "一次",
          value: chartData[0] * 100
        })
        series.push({
          name: "二次",
          value: chartData[1] * 100
        })
        series.push({
          name: "多次",
          value: chartData[2] * 100
        })

        var option = {
          grid: {
            top: 0
          },
          color: this.pieColor,
          series: [
            {
              type: 'pie',
              data: series,
              radius: '80%',
              label: {
                show: false
              },
            }
          ],
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              return params.data.name + ":" + params.data.value.toFixed(2) + '%'
            },
          },

        }
        re_pie.setOption(option)
        let categories_bar = []
        var series_bar = []
        var list = res.data.data.origin_list
        list.slice(0, 10).forEach(item => {
          categories_bar.push(item[0])
          series_bar.push((item[1][0] + item[1][1] + item[1][2]) * 100)

        })
        categories_bar.reverse()
        series_bar.reverse()
        var option_1 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function (params) {
              return params[0].name + ":" + params[0].data.toFixed(2) + "%"
            },
          },
          legend: {},
          grid: {
            top: '0',
            left: '0',
            right: '6%',
            bottom: '0',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              }
            }
          },
          yAxis: {
            type: 'category',
            data: categories_bar,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: 10      //更改坐标轴文字大小
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_bar,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        var re_bar = this.echarts.init(document.getElementById('re_bar'));
        re_bar.setOption(option_1)
      })
    },
    // 获取酒店信息
    xcxGetHotelData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.req_date, store_id: '' }
      }
      xcxGetHotelDataApi(params).then(res => {
        this.hotelData = res.data.data
        this.setHotelList()
      })
    },
    setHotelList() {
      let categories = []
      let series_data = []
      this.hotelData.room_charge_list.slice(0, 10).forEach(item => {
        var value = Object.values(item)
        var key = Object.keys(item)
        categories.push(key[0].slice(0, 5))
        series_data.push(value[0])
      })
      categories.reverse()
      series_data.reverse()
      var hotelRank = this.echarts.init(document.getElementById('hotelRank'));

      var res = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          top: '0',
          left: '6%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            }
          },
          splitNumber: 3
        },
        yAxis: {
          type: 'category',
          data: categories,
          axisLabel: {
            textStyle: {
              color: '#ffffff',
              fontSize: 10      //更改坐标轴文字大小
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          }
        },
        series: [
          {
            name: '',
            type: 'bar',
            data: series_data,
            itemStyle: {
              color: "#0437ea"
            }
          }
        ]
      }
      hotelRank.setOption(res)

    },
    getBusinessNum() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getMerchantOrder(params).then(res => {
        this.businessNum = res.data.data
      })
    },
    getBusinessList() {
      var obj = { scenic_id: this.scenic_id, time_type: 3, is_all: 1, dates: this.req_date }
      getMerchantOrderList(obj).then(res => {
        let categories = []
        let series_data = []
        let categories_1 = []
        let categories_2 = []
        let series_data_1 = []
        let series_data_2 = []
        this.merchant_order_total_list = res.data.data.merchant_order_total_list
        for (let i = 0; i < this.merchant_order_total_list.length; i++) {
          var item = this.merchant_order_total_list[i]
          if (i < 10) {
            if (item.is_scenic_own) {
              series_data.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories.push(item.name)
            } else {
              series_data.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories.push(item.name)
            }
          }
          if (this.merchant_order_total_list.length > 40) {
            if (i % 2 === 1) {
              if (item.is_scenic_own) {
                series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_1.push(item.name)
              } else {
                series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_1.push(item.name)
              }
            } else {
              if (item.is_scenic_own) {
                series_data_2.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
                categories_2.push(item.name)
              } else {
                series_data_2.push({ value: item.num, itemStyle: { color: '#063aef' } })
                categories_2.push(item.name)
              }
            }
          } else {
            if (item.is_scenic_own) {
              series_data_1.push({ value: item.num, itemStyle: { color: '#05dfd6' } })
              categories_1.push(item.name)
            } else {
              series_data_1.push({ value: item.num, itemStyle: { color: '#063aef' } })
              categories_1.push(item.name)
            }
          }
        }
        let integer
        if (this.merchant_order_total_list.length > 40) {
          integer = Math.ceil(series_data_2[0].value)
        } else {
          integer = Math.ceil(series_data_1[0].value)
        }
        categories_1.reverse()
        series_data_1.reverse()
        categories_2.reverse()
        series_data_2.reverse()
        let length = String(integer).length
        console.log(integer, length)
        let max_num = Math.ceil(integer / Math.pow(10, length - 1)) * Math.pow(10, length - 1)
        var businessRank = this.echarts.init(document.getElementById('businessRank'));
        var option = {
          grid: {
            top: "20%",
            left: "10%",
            right: "3%",
            bottom: "26%"
          },
          tooltip: {},
          xAxis: {
            axisLabel: {
              show: true,
              rotate: 36, // 倾斜30度<<<<<-----复制这里----------
              interval: 0,
              textStyle: {
                color: '#fff',
                fontSize: 10    //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: false
            },
            data: categories
          },
          yAxis: {
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 10,      //更改坐标轴文字大小
              },
            },
            splitNumber: 4,
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          barWidth: 10,
          series: [{
            data: series_data, type: 'bar'
          }]
        }
        var option_1 = {
          legend: {},
          grid: {
            top: '0',
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: '#fff',
                fontSize: 12    //更改坐标轴文字大小
              }
            },
            splitNumber: 3,
            max: max_num
          },
          yAxis: {
            type: 'category',
            data: categories_2,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 12,      //更改坐标轴文字大小
              },
            },
            formatter: function (value) {
              return value.slice(0, 5);
            }
          },
          series: [
            {
              name: '',
              type: 'bar',
              data: series_data_2,
              itemStyle: {
                color: "#0437ea"
              }
            }
          ]
        }
        if (this.merchant_order_total_list.length > 40) {
          var option_2 = {
            legend: {},
            grid: {
              top: '0',
              left: '3%',
              right: '3%',
              bottom: '3%',
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
              axisLabel: {
                show: true,
                interval: 0,
                textStyle: {
                  color: '#fff',
                  fontSize: 12    //更改坐标轴文字大小
                }
              },
              splitNumber: 3,
              max: max_num
            },
            yAxis: {
              type: 'category',
              data: categories_1,
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize: 12,      //更改坐标轴文字大小
                },
              },
              formatter: function (value) {
                return value.slice(0, 5);
              }
            },
            series: [
              {
                name: '',
                type: 'bar',
                data: series_data_1,
                itemStyle: {
                  color: "#0437ea"
                }
              }
            ]
          }
        }

        businessRank.setOption(option)
        if (this.merchant_order_total_list.length > 40) {
          var shopRank_1 = this.echarts.init(document.getElementById('shopRank_1'));
          shopRank_1.setOption(option_1)
          var shopRank_2 = this.echarts.init(document.getElementById('shopRank_2'));
          shopRank_2.setOption(option_2)
        } else {
          var shopRank = this.echarts.init(document.getElementById('shopRank'));
          shopRank.setOption(option_1)
        }
      })

    },
    getBigDataOfflineRetail() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      getBigDataOfflineRetailInfo(params).then(res => {
        this.offlineRetailInfo = res.data.data
      })
    },
    salesComparison() {
      var params = { scenic_id: this.scenic_id, dates: this.req_date }
      salesComparisonApi(params).then(res => {
        var categories = [];
        var series = [];
        var itemStyle = {
          normal: {
            lineStyle: {
              width: 0.5
            },
            borderColor: '#fff',
            borderWidth: 2
          },
        }
        series.push({ name: '总额', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '票务', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '酒店', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '线下商户', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        series.push({ name: '美食', data: [], type: 'line', smooth: true, symbol: 'circle', symbolSize: 6, itemStyle: itemStyle, areaStyle: {} })
        for (let i = res.data.data.sales_comparison_list.length - 1; i >= 0; i--) {
          var item = res.data.data.sales_comparison_list[i]
          categories.push(item.create_time.slice(5, 10))
          series[0].data.push(item.today_total_amount)
          series[1].data.push(item.ticket_sales_revenue)
          series[2].data.push(item.hotel_sales_revenue)
          series[3].data.push(item.offline_order_total)
          series[4].data.push(item.delicious_food_sales_revenue)
        }
        var thirtyDays = this.echarts.init(document.getElementById('thirtyDays'));
        var option = {
          grid: {
            top: "10%",
            left: "2%",
            right: "2%",
            bottom: "6%"
          },
          color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
          legend: {
            show: true,
            y: 'top',
            x: 'center',
            icon: 'rect',
            width: 360,
            itemWidth: 10,
            itemHeight: 10,
            align: "auto",
            textStyle: {
              color: '#fff',
              fontSize: 18
            }
          },

          xAxis: {
            boundaryGap: false,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 11
              }
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            data: categories
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            },
            axisLine: {
              show: false, // 不显示坐标轴线
            },
            splitLine: {
              show: false // 不显示网格线
            },
            axisTick: {
              show: false // 不显示坐标轴刻度线
            },
            splitNumber: 5,
          },
          lineStyle: {
            color: '#fff',
          },
          tooltip: {},
          series: series
        }
        thirtyDays.setOption(option)
      })
    },
    totalWait(obj) {
      let total = 0
      for (let key in obj) {
        total += Number((obj[key] * this.coefficient_data / 100).toFixed(0))
      }
      return total
    },
    // 近三天
    getWaitingIn() {
      getWaitingInApi({ scenic_id: this.scenic_id, dates: this.req_date }).then(res => {
        console.log("近三天", res.data.data.data)
        var chartData = res.data.data.data.slice(0, 3)
        var series = []
        series.push({ name: '待入园', data: [], type: 'bar', color: '#023aff', barWidth: 10, stack: 'x' })
        series.push({ name: '已入园', data: [], type: 'bar', color: '#01f1e3', barWidth: 10, stack: 'x' })
        var categories = [];
        console.log(this.total_tourists_num, 'this.total_tourists_num')
        for (var i = 0; i < chartData.length; i++) {
          categories.push(chartData[i].create_time.slice(5, 10))
          // series[0].data.push(chartData[i].waiting_in)
          var total = this.totalWait(chartData[i].waiting_in_list)
          series[0].data.push(total)
          if (this.total_tourists_num > 0 && i === 0) {
            series[1].data.push(this.total_tourists_num)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          } else {
            series[1].data.push(null)
            this.three_series.push({
              // data_1:chartData[i].waiting_in,
              data_1: total,
              data_2: this.total_tourists_num,
              list: chartData[i].waiting_in_list,
            })
          }

        }

        var option = {
          grid: {
            top: "6%",
            left: "26%",
            right: "3%",
            bottom: "18%"
          },
          legend: {
            show: true,
            y: 'bottom',
            icon: "circle",
            itemWidth: 5,
            itemHeight: 5,
            itemGap: 30,
            textStyle: {  // 图例文字的样式
              color: '#fff',
            },
          },
          tooltip: {},
          xAxis: {
            data: categories,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 9      //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          yAxis: {
            splitNumber: 4,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 10     //更改坐标轴文字大小
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.5)',
                type: 'dashed'
              }
            }
          },
          series: series
        }

        var waitInPart = this.echarts.init(document.getElementById('waitInPart'));
        waitInPart.setOption(option)
        this.pushThreeShow(0)
        var _this = this
        waitInPart.on('click', function (params) {
          _this.pushThreeShow(params.dataIndex)
        });
      })
    },
    pushThreeShow(index) {
      this.three_show = []
      this.three_show.push({ text: '待入园：' + this.three_series[index].data_1 + '人' })
      if (this.three_series[index].data_2 > 0 && index === 0) {
        this.three_show.push({ text: '已入园：' + this.three_series[index].data_2 + '人' })
      } else if (index === 0) {
        this.three_show.push({ text: '已入园：0人' })
      }
      var pie_show = []
      for (let key in this.three_series[index].list) {
        if (key !== '景区窗口简易端') {
          pie_show.push({ value: this.three_series[index].list[key], name: key })
        }
        var three_pie = this.echarts.init(document.getElementById('three_pie'));
        var option = {
          color: ['#01f1e3', '#bb63ff', '#ffa63f', '#f03fff', '#07a198', '#1387f4', '#1b9b35', '#e33e31'],
          padding: [0, 0, 0, 0],
          series: [
            {
              type: 'pie',
              // radius: '50%',
              data: pie_show,
              label: {
                show: false
              },
            }
          ],
          tooltip: {
            position: 'left',
            formatter: function (params) {
              return params.data.name + "：" + params.data.value
            },
          },
          legend: {
            show: false,
          }
        }
        three_pie.setOption(option)
      }

    },
    pushTrafficLine(list) {
      var list_arr = []
      list_arr.push(list[0])
      for (let i = 1; i < list.length; i++) {
        list_arr.push(list[i] - list[i - 1])
      }
      return list_arr
    },
    // 入园出园趋势
    showPeakLine(chartData) {
      var categories = [];
      var series = [];
      var order_series = [];
      if (this.isToday) {
        for (var i = 0; i < chartData.categories.length; i++) {
          if (chartData.categories[i] <= (parseInt(this.hour) + 1)) {
            categories.push(chartData.categories[i])
          } else {
            break
          }
        }
      } else {
        categories = chartData.categories;
      }
      let series_0, series_1, series_6
      series_0 = JSON.parse(JSON.stringify(chartData.series[0]));
      series_1 = JSON.parse(JSON.stringify(chartData.series[1]));
      series_6 = JSON.parse(JSON.stringify(chartData.series[6]));
      series_0.data = this.pushTrafficLine(chartData.series[0].data)
      series_1.data = this.pushTrafficLine(chartData.series[1].data)
      series_6.data = this.pushTrafficLine(chartData.series[6].data)

      console.log(series, '峰值')
      var option = {
        grid: {
          top: "20%",
          left: "12%",
          right: "5%",
          bottom: "16%"
        },
        legend: {
          show: true,
          y: 'top',
          x: 'right',
          icon: 'rect',
          width: 200,
          itemWidth: 9,
          itemHeight: 9,
          align: "auto",
          textStyle: {
            color: '#fff',
            fontSize: 10
          }
        },
        tooltip: {},
        xAxis: {
          boundaryGap: false,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            formatter: (value, index) => {
              return value + '点'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          data: this.current_traffic_trend.categories
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              fontSize: 11
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.5)',
              type: 'dashed'
            }
          },
          splitNumber: 4,
        },
        color: ['#01f1e3', '#023aff', '#bb63ff', '#ffa63f', '#f13b01', '#c40449', '#f03fff', '#07a198', '#4c4c87', '#797983'],
        series: [{
          data: series_0.data.slice(0, categories.length),
          type: 'line',
          smooth: true,
          name: series_0.name,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2
            },
          },
          areaStyle: {}
        },
        {
          data: series_1.data.slice(0, categories.length),
          type: 'line',
          smooth: true,
          name: series_1.name,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
            }
          },
          areaStyle: {}
        },
        {
          data: series_6.data.slice(0, categories.length),
          type: 'line',
          smooth: true,
          name: series_6.name,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            normal: {
              lineStyle: {
                width: 0.5
              },
              borderColor: '#fff',
              borderWidth: 2,
            }
          },
          areaStyle: {}
        }]
      }
      var peakLine = this.echarts.init(document.getElementById('peakLine'));
      peakLine.setOption(option)

    },
    getDeliciousFoodData() {
      var params = {}
      if (this.isToday) {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      } else {
        params = { scenic_id: this.scenic_id, dates: this.last_day, store_id: '' }
      }
      xcxGetDeliciousFoodDataApi(params).then(res => {
        this.deliciousFoodData = res.data.data
        for (var i = 0; i < this.deliciousFoodData.business_indicators.length; i++) {
          var obj = this.deliciousFoodData.business_indicators[i]
          if (obj.key === '翻台率') {
            this.tableTurnoverRate = obj.label
            break
          }
        }
        this.showTypePie()
      })
    },
    // 市别
    showTypePie() {
      var series = [];
      var sum = 0;
      var legend_data = {}
      for (let i = 0; i < this.deliciousFoodData.time_period_type.length; i++) {
        var data = this.deliciousFoodData.time_period_type[i]
        if (i != this.deliciousFoodData.time_period_type.length - 1) {
          series.push({ value: data.label2, name: data.key })
          this.$set(legend_data, data.key, data.label2)
        } else {
          sum = data.label2
        }
      }
      var type_pie = this.echarts.init(document.getElementById('type_pie'));
      var option = {
        color: this.pieColor,

        series: [
          {
            center: ['50%', '36%'],
            type: 'pie',
            // radius: '50%',
            data: series,
            label: {
              show: false
            }
          }
        ],
        tooltip: {
          position: 'rigth',
          formatter: function (params) {
            return params.data.name + ":" + params.data.value
          },
        },
        legend: {
          show: true,
          bottom: 0,
          textStyle: {
            color: '#fff'
          },
          formatter: function (params) {
            return params + '：' + (legend_data[params] / sum * 100).toFixed(2) + '%'
          },
        }
      }
      console.log(sum, '合计')
      type_pie.setOption(option)
    },
    // 切换总收和商细
    changeAllShop(index) {
      this.allShopIndex = index
    },
    //舆情动态
    // 滚动到底部回调
    tendenciesScroll() {
      get_dynamic_subscribe_info_list({
        page: 1,
        limit: 50
      }).then(res => {
        if (res.data.data && res.data.data.length > 0) {
          if (this.tendenciesList.length === 0 || this.listQuery.page === 1) {
            this.tendenciesList = res.data.data
          } else {
            this.tendenciesList = this.tendenciesList.concat(res.data.data)
          }
          this.listQuery.page++
        } else {
        }
      })
    },
    handleDetail(data) {
      this.isDetail = true
      this.isDetailLoading = true
      get_dynamic_subscribe_info_detail({ 'antdu_id': data.antduId }).then(res => {
        this.tendenciesItem = res.data.data
      }).finally(r => {
        this.isDetailLoading = false
      })
    },
    // 跳转到原文
    toUrl(url) {
      if (url) {
        window.open(url)
      }
    },

    //舆情列表
    handleGetList() {
      const threeDaysAgo = new Date()
      threeDaysAgo.setDate(threeDaysAgo.getDate() - 3)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_info_list({
        page: 1,
        limit: 200,
        start_date: parseTime(threeDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
      }).then(res => {
        this.total = res.data.recordsTotal
        if (res.data.data.length > 0) {
          let list = res.data.data.map(item => {
            const [datePart, timePart] = item.createAt.split(' ')
            const [hour, minute] = timePart.split(':')
            item.date = datePart
            item.time = `${hour}:${minute}`
            return item
          })
          // 按照日期排序
          list = list.sort((a, b) => {
            // 直接比较整个时间字符串
            return new Date(b.createAt) - new Date(a.createAt)
          })
          // 相同日期放一起
          this.timelineList = list.reduce((groups, item) => {
            const date = String(item.date)
            if (!groups[date]) {
              groups[date] = []
            }
            groups[date].push(item)
            return groups
          }, {})
        } else {
          this.timelineList = null
        }
      })
    },
    strictClean(richText) {
      if (!richText) return ''
      // 只保留中文、英文、数字
      return richText.replace(/[^\u4e00-\u9fa5]/g, '')
    },
    // 文本高亮
    highlightText(text, rules) {
      if (!text || !rules || rules.length === 0) return text
      // 创建匹配规则的正则表达式
      const regex = this.createHighlightRegex(rules)
      // 使用正则表达式替换匹配的文本
      return text.replace(regex, '<span class="highlight">$&</span>')
    },
    createHighlightRegex(rules) {
      // 提取所有关键词
      const keywords = new Set()

      rules.forEach(rule => {
        if (!rule) return

        // 提取规则中的关键词（简化处理，实际项目需要更复杂的解析）
        const words = rule.match(/[^&|()\s]+/g) || []
        words.forEach(word => {
          if (word && word.length > 1) { // 过滤掉单个字符
            keywords.add(word.trim())
          }
        })
      })

      // 创建正则表达式，匹配任意关键词
      if (keywords.size === 0) return /(?!)/ // 不匹配任何内容

      const pattern = Array.from(keywords).map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义正则特殊字符
      ).join('|')

      return new RegExp(`(${pattern})`, 'gi')
    },
    // 修改图片访问来源
    imgText(text) {
      if (!text) return ''
      // 去重并过滤空值
      const words = [...new Set(['<img'].filter(word => word && word.trim()))]
      if (words.length === 0) {
        return text
      }
      // 创建正则表达式，忽略大小写，全局匹配
      const regex = new RegExp(`(${words.map(word =>
        word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      ).join('|')})`, 'gi')
      // 替换匹配的文本
      return text.replace(regex, '$1 referrerPolicy="no-referrer"')
    },

    //舆情分析开始
    // 初始化图表数据
    initEchart() {
      this.initTimeTrend()
      this.initEmotion()
      this.initMediaType()
      this.initHotWeb()
    },
    // 图表重置
    resizeEchart() {
      return debounce(() => {
        this.timeTrend.resize()
        this.emotion.resize()
        this.mediaType.resize()
        this.hotWeb.resize()
      }, 200)
    },
    // 生成时间趋势折线图
    initTimeTrend() {
      this.timeTrend = echarts.init(this.$refs.timeTrend)
      this.timeTrend.setOption({
        title: {
          text: '时间趋势',
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            return `${params[0].name}<br/>数量: ${params[0].value}`
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeTrendData.x,
          axisTick: {
            show: false // 隐藏x轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        grid: {
          left: '1%',
          right: '4%',
          containLabel: true
        },
        series: [
          {
            data: this.timeTrendData.y,
            type: 'line',
            smooth: true,
            areaStyle: {},
            itemStyle: {
              normal: {
                label: { show: true, color: '#fff' }, color: '#6459cd', lineStyle: {
                  color: '#6459cd' // 改变折线颜色
                }
              }
            }
          }
        ]
      })
    },
    // 生成情绪分析饼图
    initEmotion() {
      this.emotion = echarts.init(this.$refs.emotion)
      // 计算总数
      const total = this.emotionData.reduce((sum, item) => sum + item.value, 0)
      this.emotion.setOption({
        title: {
          text: `情绪分析: ${total}`,
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          formatter: (name) => {
            const item = this.emotionData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '1%',
          right: '30%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: ['20%', '40%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            itemStyle: {
              normal: {
                color: (params) => {
                  return this.emotionType[params.name]
                }
              }
            },
            data: this.emotionData
          }
        ]
      })
    },
    // 生成媒体类型饼图
    initMediaType() {
      this.mediaType = echarts.init(this.$refs.mediaType)
      // 计算总数
      const total = this.mediaTypeData.reduce((sum, item) => sum + item.value, 0)
      this.mediaType.setOption({
        title: {
          text: `媒体类型: ${total}`,
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          type: 'scroll',
          itemGap: 5,
          textStyle: {
            fontSize: 10,
            color: '#fff'
          },
          formatter: (name) => {
            const item = this.mediaTypeData.find(d => d.name === name)
            if (item && total > 0) {
              const percent = ((item.value / total) * 100).toFixed(1)
              return `${name}: ${item.value} (${percent}%)`
            }
            return name
          }
        },
        grid: {
          left: '3%',
          right: '15%', // 为右侧图例留出空间
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            type: 'pie',
            radius: ['20%', '30%'], // 调整为环形图
            center: ['35%', '50%'], // 饼图靠左，为图例留空间
            data: this.mediaTypeData
          }
        ]
      })
    },
    // 生成热门网站柱状图
    initHotWeb() {
      this.hotWeb = echarts.init(this.$refs.hotWeb)
      this.hotWeb.setOption({
        title: {
          text: '渠道分析',
          left: 'center',
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },

        },
        legend: {
          show: false
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        yAxis: {
          type: 'category',
          data: this.hotWebData.y,
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            }
          },
        },
        grid: {
          left: '1%',
          right: '2.5%',
          containLabel: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0], // 控制 Y 轴
            width: 4, // 滚动条宽度
            right: 3, // 距离右侧的距离
            minValueSpan: 7, // 最小显示数量
            maxValueSpan: 7 // 最大显示数量
          },
          {
            type: 'inside',
            yAxisIndex: [0],
            moveOnMouseWheel: true // 鼠标滚轮触发平移
          }
        ],
        series: [
          {
            type: 'bar',
            smooth: true,
            show: false,
            areaStyle: {},
            data: this.hotWebData.x,
            itemStyle: { normal: { label: { show: true, position: 'right', color: '#fff' }, color: '#6459cd' } }
          }
        ]
      })
    },
    // 获取舆情分析数据
    getTimeTrend() {
      const sevenDaysAgo = new Date()
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)
      const nextDay = new Date()
      nextDay.setDate(nextDay.getDate() + 1)
      get_subscribe_time_trend({
        start_date: parseTime(sevenDaysAgo, '{y}-{m}-{d}'),
        end_date: parseTime(nextDay, '{y}-{m}-{d}'),
        time_type: 3,
      }).then(res => {
        const { data, emotion, mediaType, websiteName } = res.data
        if (data.length > 0) {
          this.timeTrendData.y = data.map(item => item.count)
          this.timeTrendData.x = data.map(item => parseTime(item.time_group, '{y}-{m}-{d}'))
        } else {
          this.timeTrendData = { x: [], y: [] }
        }

        if (emotion.length > 0) {
          this.emotionData = emotion.map(item => {
            if (item.emotion === '负面') {
              item.emotion = '疑似负面'
            }
            if (item.emotion === '差评') {
              item.emotion = '负面'
            }
            return {
              value: item.total,
              name: item.emotion
            }
          })
        } else {
          this.emotionData = []
        }

        if (mediaType.length > 0) {
          this.mediaTypeData = mediaType.map(item => {
            return {
              value: item.total,
              name: this.platform_type[item.mediaType]
            }
          })
        } else {
          this.mediaTypeData = []
        }
        if (websiteName.length > 0) {
          this.hotWebData.y = websiteName.map(item => item.websiteName)
          this.hotWebData.x = websiteName.map(item => item.total)
        } else {
          this.hotWebData = { x: [], y: [] }
        }
        this.initEchart()
      })
    }
    //舆情分析介绍
  }
};
</script>
<style scoped>
.sentiment-box {
  height: calc(100vh - 100px);
  display: flex;
}

.sentiment-left {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}

.sentiment-body {
  flex: 1;
  display: flex;

}

.body-left {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-right {
  height: 100%;
  flex: 1;
  padding: 10px;
}

.body-title {
  text-align: center;
  font-size: 28px;
}

.sentiment-right {
  width: 400px;
  flex-shrink: 0;
  margin: 0 10px;
}


.list-box {
  height: calc(100vh - 160px);
  overflow: auto;
  padding-right: 0;
}

.list-box::-webkit-scrollbar {
  width: 4px;
}

.list-box::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.list-box::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.list-item {
  padding: 20px 0;
  cursor: pointer;
}

.item-header {
  display: flex;
  align-items: center;
}

.avatar {
  margin-right: 14px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.avatar img {
  width: 40px;
  height: 40px;
}

.header-content {
  flex: auto;
  display: flex;
  align-items: center;
}

.header-content-left {
  flex: auto;
  display: flex;
  flex-direction: column;


}

.header-content-left .title {
  font-weight: bold;
  margin-bottom: 6px;
}

.header-content-left .content {
  font-size: 14px;
  color: #fff;
}

.header-content-right {
  flex-shrink: 0;
  margin-left: 20px;
  font-size: 14px;
  color: #6d5fe0;
}

.item-key {
  margin-top: 8px;
  font-size: 13px;
  color: #fff;
  display: flex;
}

.key-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;


}

.key {
  margin-left: 10px;
  margin-bottom: 3px;
  color: #fff;
}

.item-tap {
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 13px;
  color: #fff;
  display: flex;
}

.tap-list {
  flex: 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tap {
  margin-left: 10px;
  margin-bottom: 3px;
  padding: 2px 5px;
  background-color: #6d5fe0;
  color: #fff;
  border-radius: 2px;
}

.item-body {
  padding: 0 15px;
}

.body-text {
  font-size: 15px;
  color: #c2c0c0;
  letter-spacing: 1px;
  line-height: 22px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  /* 限制显示行数 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.body-images {
  margin-top: 10px;
  overflow: hidden;
  width: 342px;
  position: relative;


}

.body-images img {
  object-fit: cover;
  flex-shrink: 0;
  height: 80px;
  width: 110px;
  margin: 0 2px;
}

.images-list {
  display: flex;
  flex-wrap: nowrap;
}

.prev {
  color: #fff;
  position: absolute;
  left: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.prev:hover {
  background-color: rgba(52, 64, 82, .5);
}

.next {
  color: #fff;
  position: absolute;
  right: 2px;
  background-color: rgba(52, 64, 82, .7);
  padding: 3px;
  font-size: 14px;
  top: 30px;
}

.next:hover {
  background-color: rgba(52, 64, 82, .5);
}

.img-total {
  position: absolute;
  left: 5px;
  bottom: 5px;
  font-size: 12px;
  color: #fff;
  padding: 2px 3px;
  line-height: 12px;
  background-color: rgba(86, 105, 133, 1);
}

.box-right {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
}

.right-header {
  flex-shrink: 0;
}

.right-body {
  flex: 1;
  overflow-y: scroll;
}

.right-body-text {
  white-space: pre-line;
  font-size: 15px;
  color: #fff;
  letter-spacing: 1px;
  line-height: 22px;
}

/deep/ .right-body-text p {
  margin: 5px 0;
}

/deep/ .right-body-text img {
  display: inline-block;
  width: 100%;
  margin: 3px;
}

.right-body-images img {
  display: inline-block;
  max-width: 100%;
  margin: 3px;
}

.right-body::-webkit-scrollbar {
  width: 4px;
  position: fixed;
  right: 0;
}

.right-body::-webkit-scrollbar-thumb {
  background: #a8a8a8;
  border-radius: 4px;
}


.timeline {
  width: 28vw;
  height: calc(100vh - 160px);
  overflow-y: scroll;
}

.timeline-date {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 10px 0;
  color: #fff;
  font-weight: bold;
}

.timeline-date:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.date-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.date-item1 {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-item {
  position: relative;
}

.timeline-item:before {
  content: '';
  position: absolute;
  left: 8px;
  background-color: #6459cd;
  width: 1px;
  height: 100%;
}

.timeline-span {
  margin-right: 10px;
  /* background-color: #fff; */
  width: 17px;
  height: 17px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;


}

.span-item1 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #6459cd;
}

.timeline-content {
  display: flex;
  align-items: center;
  padding: 14px 0;
}

.timeline-time {
  flex-shrink: 0;
  font-size: 14px;
  margin-right: 10px;
}

.timeline-text {
  cursor: pointer;
  flex: 1;
  font-size: 16px;
  color: #dad8d8;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  letter-spacing: 1px;
}

.timeline-website {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-box {
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  margin-left: 10px;
}

.timeline::-webkit-scrollbar {
  width: 4px;
}

.timeline::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 4px;
}

.timeline::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

.migrateMap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* max-height:calc(100% + 180px) ; */
  background-color: #555;
  z-index: 0;
  min-height: 100vh;
}

.centenr-echart {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 0;
}

.centenrBox {
  width: 1330px;
  height: 900px;
}

.centenrBox-chart {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
}

.shop-charts-btn {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 1230px;
  height: 800px;
  display: flex;
  justify-content: space-around;
}

.shop-charts-01 {
  width: 1200px;
  height: 800px;
}

.shop-charts-02 {
  width: 500px;
  height: 800px;
}

.all_or_shop {
  display: flex;
  justify-content: center;
}

.all_or_shop_btn {
  width: 120px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 6px;
}

.all_or_shop_on {
  background-color: #060c41;
  border: 1px solid #04dccf;
  color: #04dccf;
}

.all_or_shop_btn:hover {
  cursor: pointer;
}

/* .migrateMap1{
  position: relative;
  top:0;
  left: 0;
  width: 100%;
  height: 571px;
  background-color: rgba(0,0,0,0);
} */
/* 头部开始 */
.head {
  position: relative;
  display: flex;
  padding: 0 20px;
  width: 100%;
  height: 54px;
  line-height: 54px;
  background-color: #141439;
  justify-content: space-between;
  z-index: 1;
}

.head-title {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
}

.head-logo {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.date-weather {
  display: inline-block;
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
  background-color: #040932;
  font-size: 13px;
  border-radius: 17px;
  vertical-align: middle;
}

.head-type {

  width: 417px;
  max-width: 100%;
  height: 54px;
  display: flex;
  justify-content: space-around;
  vertical-align: middle;
}

.type-item {
  position: relative;
  height: 100%;
  display: inline-block;
  color: #575785;
  cursor: pointer;

}

.type-on {
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #023AFF;
  border-radius: 1px;
}

.type-item2 {
  color: #fff;
}

/* 头部结束 */
/* 主体开始 */
.main {
  width: 100%;
  padding-top: 28px;
  /* box-sizing: border-box; */
  /* display: flex; */
  /* justify-content: space-between; */
  /* min-height: calc(100vh - 54px); */
  /* align-items:flex-end */
}

.main_type {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  /* min-height: calc(100vh - 54px); */
  align-items: flex-end
}

.data-box {
  background-color: #030A45;
  opacity: 0.9;
  box-shadow: -1px -1px 10px 2px rgba(78, 240, 228, 0.1);
  background-image: url(../../static/img/border-top.png),
    url(../../static/img/border-bottom.png);
  background-repeat: no-repeat, no-repeat;
  background-position: left top, right bottom;
  background-position: -0.3% -0.3%, 100.3% 100.3%;
}

/* 左边开始 */
.main-left {
  position: relative;
  /* flex-grow: 1; */
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
}

/* 左边顶部开始 */
.left-top {
  padding: 15px;
  padding-top: 35px;
  width: 100%;
  height: 326px;
  box-sizing: border-box;

  z-index: 1;
}

.left-top-main {
  width: 100%;
}

.left-top-title {
  color: #fff;
  text-align: left;
  align-items: center;
}

.year-sum-box {
  width: 291px;
  height: 57px;
  background: url(../../static/img/num-box.png) no-repeat;
  background-size: 100% 57px;
}

.year-sum {
  margin: 0 -2px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.center-big-title {
  margin-block: 6px;
  /* line-height: 81px;
  height: 81px; */
  vertical-align: top;
  color: #98bfbd;
  font-weight: 600;
  font-size: 20px;
  text-align: center;
}

.today-sum-one {
  width: 420px;
  height: 96px;
  background: url(../../static/img/num-box.png) no-repeat;
  background-size: auto 96px;
  background-position: left
}

.year-sum-big {
  position: relative;
  margin: 0 -3px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 4px);
  line-height: 57px;
  text-align: center;
}

.sum-one-big {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 80px;
}

.center-icon {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 60px;
}

.sum-one {
  display: inline-block;
  /* margin-left:22px; */
  font-weight: 600;
  font-size: 33px
}

/* .sum-one:first-child{
   margin-left:0px;
} */
.today-sum {
  display: flex;
  justify-content: space-between;
}

.today-one {
  flex-basis: 50%;
  text-align: center;
}

.today-one-title {
  margin: 8px 0 9px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.today-one-sum {
  display: inline-block;
  width: 137px;
  height: 37px;
  background: url(../../static/img/small-num-box.png) no-repeat;
}

.today-one-sum-box {
  margin: 0 -1px;
  line-height: 37px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
  width: calc(100% + 2px);
}

.today-one-num {
  display: inline-block;
  /* margin-left: 13px; */

}

/* .today-one-num:first-child{
   margin-left: 0;
} */
.last-num {
  width: 100%;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
}

/* 左边顶部结束 */
/* 左边中间开始 */
.left-center {
  margin-top: 11px;
  padding: 10px;
  width: 100%;
  height: 240px;
  box-sizing: border-box;
}

.inPercentage {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}

.saturation {
  text-align: center;
}

.saturation-per {
  display: inline-block;
  width: 119px;
  height: 119px;
  background-image: url(../../static/img/Chart_bg.png);
  background-size: 102px 102px;
  background-position: center center;
  background-repeat: no-repeat;
}

.inPercentageRemark {
  margin-top: 13px;
  display: inline-block;
  height: 14px;
  line-height: 14px;
}

.little-bar {
  display: inline-block;
  width: 16px;
  height: 2px;
  vertical-align: middle;
}

/* 左边中间结束 */
/* 左边下部开始 */
.left-bottom {
  margin-top: 10px;
  width: 100%;
  height: 266px;
  box-sizing: border-box;
}

.left-bottom-title {
  padding: 10px;
  font-size: 16px;
  color: #fff;
}

.gender {
  position: relative;
  padding-left: 5px;
  height: 80px;
}

.a-gender {
  margin-left: 10px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
  transform: translate(0, 15px);
}

.a-gender>img {
  display: inline-block;
  width: 26px;
  height: 26px;
}

.gender-content {
  height: 14px;
  font-size: 10px;
  line-height: 14px
}

.matinee {
  display: inline-block;
  width: 110px;
  height: 105px;
  text-align: right;
}

.ota_pie {
  display: inline-block;
  width: 110px;
  height: 100px;
  text-align: right;
}

.pie-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 3px;
  vertical-align: middle;
}

.pie-text-item {
  display: inline-block;
  margin: 3px 6px 0 0;
  font-size: 10px;
}

.gender-column {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 105px;
}

.travel-person {
  margin-left: 7px;
  display: inline-block;
  width: 190px;
  height: 200px;
}

/* 左边下部结束 */
/* 左边结束 */
/* 中间开始 */
.main-center {
  flex-grow: 1;
  min-width: 720px;
  position: relative;
  height: 300px;
}

.heat-address {
  position: absolute;
  padding-left: 10px;
  top: 0;
  right: -119px;
  width: 102px;
  height: 36px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 145px 65px;
  background-position: right top, left bottom, center center;
  font-size: 16px;
  color: #01F1E3;
  line-height: 36px;
  font-weight: 600;
}

.heat-address>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -2px);
}

.charts {
  left: 0;
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.inOrOut {
  position: relative;
  width: 457px;
  height: 268px;
}

.inOrOut-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 425px;
  height: 256px;
}

.inTime {
  position: relative;
  width: 457px;
  height: 268px;
}

.inTime-chart {
  position: absolute;
  top: 11px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 425px;
  height: 256px;
}

/* 中间结束 */
/* 右边开始 */
.main-right {
  position: relative;
  margin: 0 20px 15px 20px;
  width: 320px;
  box-sizing: border-box;
  z-index: 1;
}

.changeDates {
  position: absolute;
  top: 0;
  left: -280px;
}

.changeDateOne {
  margin-right: 10px;
  display: inline-block;
  width: 66px;
  height: 32px;
  font-size: 15px;
  text-align: center;
  color: #01F1E3;
  line-height: 32px;
  font-weight: 600;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-size: auto auto, auto auto, 110px 65px;
  background-position: right top, left bottom, center center;
  cursor: pointer;
}

/* 右边顶部开始 */
.right-top {
  width: 100%;
  height: 301px;
  box-sizing: border-box;
}

.right-title {
  position: relative;
  padding: 15px 10px;
  color: #fff;
  font-size: 16px;
  text-align: left;
}

.right-datetiem {
  position: absolute;
  padding-left: 8px;
  top: 15px;
  right: 10px;
  width: 55px;
  height: 22px;
  background-image: url(../../static/img/year-top.png),
    url(../../static/img/year-bottom.png),
    url(../../static/img/year-bgc.png);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: right top, left bottom, center center;
  font-size: 10px;
  color: #01F1E3;
  line-height: 22px;
  font-weight: 600;
}

.right-datetiem>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originTypeBox {
  position: relative;
  width: 100%;
}

.originTypeBox>img {
  display: inline-block;
  vertical-align: middle;
  transform: translate(0, -1px);
}

.originType {
  position: absolute;
  bottom: -75px;
  left: -8px;
  width: 66px;
  background-color: #08153b;
  border: 1px solid #01f1e3;
  z-index: 999;
}

.originTypeOne {
  padding: 0 4px;
  height: 24px;
  line-height: 24px;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #01f1e3;
}

.originTypeOne:last-child {
  border-bottom: 0px solid #01f1e3;
}

.touristType {
  margin: 0 auto;
  width: 100%;
  height: 240px;
}

/* 右边顶部结束 */
/* 右边中间开始 */
.right-center {
  margin-top: 20px;
  width: 100%;
  height: 261px;
  box-sizing: border-box;
}

.address {
  width: 200px;
  height: 196px;
}

.addressList {
  display: inline-block;
  position: absolute;
  width: 100px;
  top: 50%;
  right: 8px;
  transform: translate(0, 22px);
}

.addressListOne {
  width: 60px;
  height: 20px;
  line-height: 20px;
  color: #aaabb0;
  font-size: 9px;
}

.addressBar {
  position: absolute;
  display: inline-block;
  width: 70px;
  height: 200px;
  top: 0;
  right: 0;
}

/* 右边中间结束 */
/* 右边底部开始 */
.right-bottom {
  margin-top: 16px;
  width: 100%;
  height: 258px;
  box-sizing: border-box;
}

.touristLine {
  margin: 0 auto;
  width: 285px;
  height: 192px;

}

/* 右边底部结束 */
/* 右边结束 */
/* 第二部分左边开始 */
.cityCome {
  position: relative;
  width: 360px;
  height: 268px;
}

.cityCome-chart {
  position: absolute;
  bottom: 18px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 350px;
  height: 200px;
}

.cityInput {
  padding: 0 6px;
  box-sizing: border-box;
  display: inline-block;
  width: 88px;
  height: 30px;
  line-height: 30px;
  z-index: 999;
}

.city-btn {
  margin-left: 6px;
  display: inline-block;
  width: 50px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: #1e5c79;
  border-radius: 6px;
}

.city-btn:hover {
  cursor: pointer;
}

.onOldCome {
  background-color: #0081c3;
}

.number-big {
  margin-top: 10px;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
}

.number-small {
  margin-left: 14px;
  color: #01F1E3;
  font-size: 16px;
}

.title-small {
  display: inline-block;
  transform: translate(0, -2px);
}

.title-small-third {
  display: inline-block;
  width: 60px;
  text-align-last: justify;
  text-align: left;
}

.charts-percent {
  font-size: 12px;
  color: #fff;
  line-height: 12px;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

.ticket-dot {
  margin-left: 10px;
  margin-right: 6px;
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.three-day {
  margin-left: 6px;
  margin-top: 18px;
  display: inline-block;
  width: 108px;
  vertical-align: top;
  font-size: 12px;
  /* text-align-last: justify; */
}

.rank-box {
  position: relative;
  display: inline-block;
  width: 178px;
  height: 278px;
}

.rank-charts {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translate(-50%, 0);
}

.center-top-num {
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 18px;
}

.date-weather {
  background: transparent;
  border: 0;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/ScenicDateData.vue